/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		return installedChunks[chunkId][2] = promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

var g;

// This works in non-strict mode
g = (function() { return this; })();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports["parallel-es"]=n():t["parallel-es"]=n()}(this,function(){return function(t){function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}var e={};return n.m=t,n.c=e,n.i=function(t){return t},n.d=function(t,n,e){Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=168)}(function(t){for(var n in t)if(Object.prototype.hasOwnProperty.call(t,n))switch(typeof t[n]){case"function":break;case"object":t[n]=function(n){var e=n.slice(1),r=t[n[0]];return function(t,n,i){r.apply(this,[t,n,i].concat(e))}}(t[n]);break;default:t[n]=t[t[n]]}return t}([function(t,n){"use strict";n.__esModule=!0,n.default=function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(77),o=r(i);n.default=function(){function t(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(t,r.key,r)}}return function(n,e,r){return e&&t(n.prototype,e),r&&t(n,r),n}}()},function(t,n){var e=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=e)},function(t,n,e){var r=e(32)("wks"),i=e(22),o=e(4).Symbol,u="function"==typeof o,a=t.exports=function(t){return r[t]||(r[t]=u&&o[t]||(u?o:i)("Symbol."+t))};a.store=r},function(t,n){var e=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},function(t,n,e){var r=e(14);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,n,e){var r=e(5),i=e(51),o=e(39),u=Object.defineProperty;n.f=e(7)?Object.defineProperty:function(t,n,e){if(r(t),n=o(n,!0),r(e),i)try{return u(t,n,e)}catch(t){}if("get"in e||"set"in e)throw TypeError("Accessors not supported!");return"value"in e&&(t[n]=e.value),t}},function(t,n,e){t.exports=!e(19)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(6),i=e(20);t.exports=e(7)?function(t,n,e){return r.f(t,n,i(1,e))}:function(t,n,e){return t[n]=e,t}},function(t,n,e){var r=e(87),i=e(24);t.exports=function(t){return r(i(t))}},function(t,n,e){var r=e(4),i=e(2),o=e(17),u=e(8),a="prototype",s=function(t,n,e){var c,f,l,h=t&s.F,d=t&s.G,v=t&s.S,p=t&s.P,y=t&s.B,m=t&s.W,k=d?i:i[n]||(i[n]={}),g=k[a],b=d?r:v?r[n]:(r[n]||{})[a];d&&(e=n);for(c in e)f=!h&&b&&void 0!==b[c],f&&c in k||(l=f?b[c]:e[c],k[c]=d&&"function"!=typeof b[c]?e[c]:y&&f?o(l,r):m&&b[c]==l?function(t){var n=function(n,e,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(n);case 2:return new t(n,e)}return new t(n,e,r)}return t.apply(this,arguments)};return n[a]=t[a],n}(l):p&&"function"==typeof l?o(Function.call,l):l,p&&((k.virtual||(k.virtual={}))[c]=l,t&s.R&&g&&!g[c]&&u(g,c,l)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},function(t,n){var e={}.hasOwnProperty;t.exports=function(t,n){return e.call(t,n)}},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o);e.d(n,"a",function(){return a});var a=function(){function t(n,e){i()(this,t),this.func=n,this.params=e}return u()(t,null,[{key:"create",value:function(n){for(var e=arguments.length,r=Array(e>1?e-1:0),i=1;i<e;i++)r[i-1]=arguments[i];return new t(n,r)}},{key:"createUnchecked",value:function(n){for(var e=arguments.length,r=Array(e>1?e-1:0),i=1;i<e;i++)r[i-1]=arguments[i];return new t(n,r)}},{key:"fromSerialized",value:function(n){return new t(n.functionId,n.parameters)}}]),t}()},function(t,n,e){t.exports={default:e(83),__esModule:!0}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){t.exports={}},function(t,n,e){"use strict";function r(t,n){return{_______isFunctionId:!0,identifier:t+"-"+n}}function i(t){return!!t&&t._______isFunctionId===!0}n.a=r,n.b=i},function(t,n,e){var r=e(35);t.exports=function(t,n,e){if(r(t),void 0===n)return t;switch(e){case 1:return function(e){return t.call(n,e)};case 2:return function(e,r){return t.call(n,e,r)};case 3:return function(e,r,i){return t.call(n,e,r,i)}}return function(){return t.apply(n,arguments)}}},function(t,n){var e={}.toString;t.exports=function(t){return e.call(t).slice(8,-1)}},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,e){var r=e(6).f,i=e(11),o=e(3)("toStringTag");t.exports=function(t,n,e){t&&!i(t=e?t:t.prototype,o)&&r(t,o,{configurable:!0,value:n})}},function(t,n){var e=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++e+r).toString(36))}},function(t,n,e){"use strict";var r=e(16);e.d(n,"a",function(){return i});var i={FILTER:e.i(r.a)("parallel",0),IDENTITY:e.i(r.a)("parallel",1),MAP:e.i(r.a)("parallel",2),PARALLEL_JOB_EXECUTOR:e.i(r.a)("parallel",3),RANGE:e.i(r.a)("parallel",4),REDUCE:e.i(r.a)("parallel",5),TIMES:e.i(r.a)("parallel",6),TO_ITERATOR:e.i(r.a)("parallel",7)}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n){t.exports=!0},function(t,n,e){var r=e(54),i=e(31);t.exports=Object.keys||function(t){return r(t,i)}},function(t,n,e){var r=e(32)("keys"),i=e(22);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,n){var e=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:e)(t)}},function(t,n,e){"use strict";var r=e(97)(!0);e(43)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,n=this._t,e=this._i;return e>=n.length?{value:void 0,done:!0}:(t=r(n,e),this._i+=t.length,{value:t,done:!1})})},function(t,n,e){var r=e(14),i=e(4).document,o=r(i)&&r(i.createElement);t.exports=function(t){return o?i.createElement(t):{}}},function(t,n){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,n,e){var r=e(4),i="__core-js_shared__",o=r[i]||(r[i]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,e){"use strict";function r(t){return!!t&&t.______serializedFunctionCall===!0}n.a=r},function(t,n,e){"use strict";var r=e(13),i=e.n(r),o=e(48),u=e.n(o),a=e(0),s=e.n(a),c=e(1),f=e.n(c),l=e(121),h=e(120);e.d(n,"a",function(){return d});var d=function(){function t(n){var e=this;s()(this,t),this.nextHandlers=[];var r=function(t,n,r){return e._next(t,n,r)},i=function(t){return e.reject(t)},o=function(t){return e.resolve(t)};n(r,o,i),this.promise=new u.a(function(t,n){e.resolve=t,e.reject=n})}return f()(t,[{key:"subscribe",value:function(t,n,e){return this.nextHandlers.push(t),(n||e)&&this.promise.then(e,n),this}},{key:"then",value:function(t,n){return this.promise.then(t,n)}},{key:"catch",value:function(t){return this.promise.catch(t)}},{key:"_next",value:function(t,n,e){var r=!0,o=!1,u=void 0;try{for(var a,s=i()(this.nextHandlers);!(r=(a=s.next()).done);r=!0){var c=a.value;c.apply(void 0,arguments)}}catch(t){o=!0,u=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw u}}}}],[{key:"transform",value:function(n,e){var r=void 0,i=void 0,o=void 0,u=new t(function(t,n,e){r=t,i=n,o=e});return n.subscribe(r,o,function(t){return i(e(t))}),u}},{key:"fromTasks",value:function(t,n,e){return 0===t.length?new h.a(n):new l.a(t,n,e)}}]),t}()},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,e){var r=e(5),i=e(93),o=e(31),u=e(27)("IE_PROTO"),a=function(){},s="prototype",c=function(){var t,n=e(30)("iframe"),r=o.length,i="<",u=">";for(n.style.display="none",e(50).appendChild(n),n.src="javascript:",t=n.contentWindow.document,t.open(),t.write(i+"script"+u+"document.F=Object"+i+"/script"+u),t.close(),c=t.F;r--;)delete c[s][o[r]];return c()};t.exports=Object.create||function(t,n){var e;return null!==t?(a[s]=r(t),e=new a,a[s]=null,e[u]=t):e=c(),void 0===n?e:i(e,n)}},function(t,n,e){var r=e(28),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,n,e){var r=e(24);t.exports=function(t){return Object(r(t))}},function(t,n,e){var r=e(14);t.exports=function(t,n){if(!r(t))return t;var e,i;if(n&&"function"==typeof(e=t.toString)&&!r(i=e.call(t)))return i;if("function"==typeof(e=t.valueOf)&&!r(i=e.call(t)))return i;if(!n&&"function"==typeof(e=t.toString)&&!r(i=e.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,n,e){var r=e(49),i=e(3)("iterator"),o=e(15);t.exports=e(2).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,n,e){e(101);for(var r=e(4),i=e(8),o=e(15),u=e(3)("toStringTag"),a=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],s=0;s<5;s++){var c=a[s],f=r[c],l=f&&f.prototype;l&&!l[u]&&i(l,u,c),o[c]=o.Array}},function(t,n,e){"use strict";var r=e(68),i=(e.n(r),e(62)),o=(e.n(i),e(65)),u=(e.n(o),e(66)),a=(e.n(u),e(45)),s=e(69),c=(e.n(s),e(67)),f=(e.n(c),e(70));e.n(f);e.o(r,"IParallel")&&e.d(n,"a",function(){return r.IParallel}),e.o(i,"IParallelChain")&&e.d(n,"b",function(){return i.IParallelChain}),e.o(o,"IParallelTaskEnvironment")&&e.d(n,"c",function(){return o.IParallelTaskEnvironment}),e.o(o,"IParallelEnvironment")&&e.d(n,"d",function(){return o.IParallelEnvironment}),e.o(u,"IParallelJob")&&e.d(n,"e",function(){return u.IParallelJob}),e.d(n,"f",function(){return a.IParallelOptions}),e.d(n,"g",function(){return a.IDefaultInitializedParallelOptions}),e.o(s,"IParallelJobScheduler")&&e.d(n,"h",function(){return s.IParallelJobScheduler}),e.o(c,"IParallelOperation")&&e.d(n,"i",function(){return c.IParallelOperation}),e.o(c,"ISerializedParallelOperation")&&e.d(n,"j",function(){return c.ISerializedParallelOperation}),e.o(f,"IParallelStream")&&e.d(n,"k",function(){return f.IParallelStream})},function(t,n,e){"use strict";var r=e(25),i=e(10),o=e(57),u=e(8),a=e(11),s=e(15),c=e(90),f=e(21),l=e(53),h=e(3)("iterator"),d=!([].keys&&"next"in[].keys()),v="@@iterator",p="keys",y="values",m=function(){return this};t.exports=function(t,n,e,k,g,b,_){c(e,n,k);var w,x,O,P=function(t){if(!d&&t in E)return E[t];switch(t){case p:return function(){return new e(this,t)};case y:return function(){return new e(this,t)}}return function(){return new e(this,t)}},S=n+" Iterator",I=g==y,T=!1,E=t.prototype,j=E[h]||E[v]||g&&E[g],M=j||P(g),F=g?I?P("entries"):M:void 0,R="Array"==n?E.entries||j:j;if(R&&(O=l(R.call(new t)),O!==Object.prototype&&(f(O,S,!0),r||a(O,h)||u(O,h,m))),I&&j&&j.name!==y&&(T=!0,M=function(){return j.call(this)}),r&&!_||!d&&!T&&E[h]||u(E,h,M),s[n]=M,s[S]=m,g)if(w={values:I?M:P(y),keys:b?M:P(p),entries:F},_)for(x in w)x in E||o(E,x,w[x]);else i(i.P+i.F*(d||T),n,w);return w}},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o);e.d(n,"a",function(){return a});var a=function(){function t(n){i()(this,t),this.functionRegistry=n}return u()(t,[{key:"serializeFunctionCall",value:function(t){var n=this.functionRegistry.getOrSetId(t.func);return{______serializedFunctionCall:!0,functionId:n,parameters:t.params}}}]),t}()},function(t,n,e){"use strict";function r(t){var n=!0,e=!1,r=void 0;try{for(var i,a=o()(u);!(n=(i=a.next()).done);n=!0){var s=i.value,c=t[s];if("undefined"!=typeof c&&("number"!=typeof c||c<=0||c%1!==0))throw new Error("Illegal parallel options: "+s+" ("+c+") has to be an integer greater than zero")}}catch(t){e=!0,r=t}finally{try{!n&&a.return&&a.return()}finally{if(e)throw r}}if("undefined"!=typeof t.minValuesPerTask&&"undefined"!=typeof t.maxValuesPerTask&&t.minValuesPerTask>t.maxValuesPerTask)throw new Error("Illegal parallel options: minValuesPerTask ("+t.minValuesPerTask+") must be equal or less than maxValuesPerTask ("+t.maxValuesPerTask+").")}var i=e(13),o=e.n(i);n.a=r;var u=["maxValuesPerTask","minValuesPerTask","maxDegreeOfParallelism"]},function(t,n,e){"use strict";function r(t){if(0===t.length)return[];var n=u()(t),e=n[0],r=n.slice(1);return Array.prototype.concat.apply(e,r)}function i(t,n){var e=t.length;t.length+=n.length;for(var r=0;r<n.length;++r)t[e+r]=n[r];return t}var o=e(80),u=e.n(o),a=e(13);e.n(a);n.b=r,n.a=i},function(t,n,e){t.exports={default:e(138),__esModule:!0}},function(t,n,e){t.exports={default:e(140),__esModule:!0}},function(t,n,e){var r=e(18),i=e(3)("toStringTag"),o="Arguments"==r(function(){return arguments}()),u=function(t,n){try{return t[n]}catch(t){}};t.exports=function(t){var n,e,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(e=u(n=Object(t),i))?e:o?r(n):"Object"==(a=r(n))&&"function"==typeof n.callee?"Arguments":a}},function(t,n,e){t.exports=e(4).document&&document.documentElement},function(t,n,e){t.exports=!e(7)&&!e(19)(function(){return 7!=Object.defineProperty(e(30)("div"),"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(55),i=e(20),o=e(9),u=e(39),a=e(11),s=e(51),c=Object.getOwnPropertyDescriptor;n.f=e(7)?c:function(t,n){if(t=o(t),n=u(n,!0),s)try{return c(t,n)}catch(t){}if(a(t,n))return i(!r.f.call(t,n),t[n])}},function(t,n,e){var r=e(11),i=e(38),o=e(27)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,n,e){var r=e(11),i=e(9),o=e(86)(!1),u=e(27)("IE_PROTO");t.exports=function(t,n){var e,a=i(t),s=0,c=[];for(e in a)e!=u&&r(a,e)&&c.push(e);for(;n.length>s;)r(a,e=n[s++])&&(~o(c,e)||c.push(e));return c}},function(t,n){n.f={}.propertyIsEnumerable},function(t,n,e){var r=e(10),i=e(2),o=e(19);t.exports=function(t,n){var e=(i.Object||{})[t]||Object[t],u={};u[t]=n(e),r(r.S+r.F*o(function(){e(1)}),"Object",u)}},function(t,n,e){t.exports=e(8)},function(t,n,e){var r=e(4),i=e(2),o=e(25),u=e(59),a=e(6).f;t.exports=function(t){var n=i.Symbol||(i.Symbol=o?{}:r.Symbol||{});"_"==t.charAt(0)||t in n||a(n,t,{value:u.f(t)})}},function(t,n,e){n.f=e(3)},function(t,n,e){"use strict";var r=e(42),i=e(71),o=(e.n(i),e(72)),u=(e.n(o),e(61)),a=(e.n(u),e(16)),s=e(12),c=e(33),f=e(44),l=e(73),h=(e.n(l),e(42));e.d(n,"a",function(){return r.a}),e.o(i,"ITaskDefinition")&&e.d(n,"b",function(){return i.ITaskDefinition}),e.o(o,"ITask")&&e.d(n,"c",function(){return o.ITask}),e.o(u,"IFunctionDefinition")&&e.d(n,"d",function(){return u.IFunctionDefinition}),e.d(n,"e",function(){return a.IFunctionId}),e.d(n,"f",function(){return a.b}),e.d(n,"g",function(){return s.a}),e.d(n,"h",function(){return c.ISerializedFunctionCall}),e.d(n,"i",function(){return c.a}),e.d(n,"j",function(){return f.a}),e.o(l,"IThreadPool")&&e.d(n,"k",function(){return l.IThreadPool}),e.d(n,"l",function(){return h.b}),e.d(n,"m",function(){return h.c}),e.d(n,"n",function(){return h.d}),e.d(n,"o",function(){return h.e}),e.d(n,"p",function(){return h.f}),e.d(n,"q",function(){return h.g}),e.d(n,"r",function(){return h.h}),e.d(n,"s",function(){return h.i}),e.d(n,"t",function(){return h.j}),e.d(n,"u",function(){return h.k})},function(t,n){},function(t,n){},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(112);e.d(n,"a",function(){return s});var s=function(){function t(n,e,r){i()(this,t),this.options=e,this.environment=r,this.stream=n}return u()(t,[{key:"resolve",value:function(){return this}},{key:"chainOperation",value:function(t){return new a.a(this.stream,this.options,this.environment,[t])}},{key:"addEnvironment",value:function(t){return new a.a(this.stream,this.options,this.environment.add(t))}}]),t}()},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(23),s=e(12);e.d(n,"a",function(){return c});var c=function(){function t(n){i()(this,t),this.collection=n}return u()(t,[{key:"serializeSlice",value:function(t,n,e){var r=n*t,i=r+n;return e.serializeFunctionCall(s.a.createUnchecked(a.a.TO_ITERATOR,this.collection.slice(r,i)))}},{key:"length",get:function(){return this.collection.length}}]),t}()},62,62,function(t,n){},62,62,62,61,61,62,function(t,n,e){"use strict";function r(t){for(var n=arguments.length,e=Array(n>1?n-1:0),r=1;r<n;r++)e[r-1]=arguments[r];if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var i=1;i<arguments.length;i++){var o=arguments[i];if(null!=o)for(var u in o)Object.prototype.hasOwnProperty.call(o,u)&&(t[u]=o[u])}return t}n.a=r},function(t,n,e){"use strict";function r(t){return{type:d.InitializeWorker,workerId:t}}function i(t){return{task:t,type:d.ScheduleTask}}function o(t){for(var n=arguments.length,e=Array(n>1?n-1:0),r=1;r<n;r++)e[r-1]=arguments[r];return{functions:t,missingFunctions:e,type:d.FunctionResponse}}function u(){return{type:d.Stop}}function a(t){return t.type===d.FunctionRequest}function s(t){return t.type===d.WorkerResult}function c(t){return t.type===d.FunctionExecutionError}var f=e(125),l=(e.n(f),e(128)),h=(e.n(l),e(13));e.n(h);n.e=r,n.f=i,n.d=o,n.g=u,n.a=a,n.b=s,n.c=c;var d;!function(t){t[t.InitializeWorker=0]="InitializeWorker",t[t.ScheduleTask=1]="ScheduleTask",t[t.FunctionRequest=2]="FunctionRequest",t[t.FunctionResponse=3]="FunctionResponse",t[t.WorkerResult=4]="WorkerResult",t[t.FunctionExecutionError=5]="FunctionExecutionError",t[t.Stop=6]="Stop"}(d||(d={}))},function(t,n,e){t.exports={default:e(133),__esModule:!0}},function(t,n,e){t.exports={default:e(84),__esModule:!0}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(129),o=r(i),u=e(126),a=r(u),s=e(82),c=r(s);n.default=function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+("undefined"==typeof n?"undefined":(0,c.default)(n)));t.prototype=(0,a.default)(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(o.default?(0,o.default)(t,n):t.__proto__=n)}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(82),o=r(i);n.default=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!==("undefined"==typeof n?"undefined":(0,o.default)(n))&&"function"!=typeof n?t:n}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(76),o=r(i);n.default=function(t){return Array.isArray(t)?t:(0,o.default)(t)}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(76),o=r(i);n.default=function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return(0,o.default)(t)}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(131),o=r(i),u=e(130),a=r(u),s="function"==typeof a.default&&"symbol"==typeof o.default?function(t){return typeof t}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":typeof t};n.default="function"==typeof a.default&&"symbol"===s(o.default)?function(t){return"undefined"==typeof t?"undefined":s(t)}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":"undefined"==typeof t?"undefined":s(t)}},function(t,n,e){e(41),e(29),t.exports=e(100)},function(t,n,e){e(102);var r=e(2).Object;t.exports=function(t,n,e){return r.defineProperty(t,n,e)}},function(t,n){t.exports=function(){}},function(t,n,e){var r=e(9),i=e(37),o=e(99);t.exports=function(t){return function(n,e,u){var a,s=r(n),c=i(s.length),f=o(u,c);if(t&&e!=e){for(;c>f;)if(a=s[f++],a!=a)return!0}else for(;c>f;f++)if((t||f in s)&&s[f]===e)return t||f||0;return!t&&-1}}},function(t,n,e){var r=e(18);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,n,e){var r=e(15),i=e(3)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||o[i]===t)}},function(t,n,e){var r=e(5);t.exports=function(t,n,e,i){try{return i?n(r(e)[0],e[1]):n(e)}catch(n){var o=t.return;throw void 0!==o&&r(o.call(t)),n}}},function(t,n,e){"use strict";var r=e(36),i=e(20),o=e(21),u={};e(8)(u,e(3)("iterator"),function(){return this}),t.exports=function(t,n,e){t.prototype=r(u,{next:i(1,e)}),o(t,n+" Iterator")}},function(t,n,e){var r=e(3)("iterator"),i=!1;try{var o=[7][r]();o.return=function(){i=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,n){if(!n&&!i)return!1;var e=!1;try{var o=[7],u=o[r]();u.next=function(){return{done:e=!0}},o[r]=function(){return u},t(o)}catch(t){}return e}},function(t,n){t.exports=function(t,n){return{value:n,done:!!t}}},function(t,n,e){var r=e(6),i=e(5),o=e(26);t.exports=e(7)?Object.defineProperties:function(t,n){i(t);for(var e,u=o(n),a=u.length,s=0;a>s;)r.f(t,e=u[s++],n[e]);return t}},function(t,n,e){var r=e(9),i=e(95).f,o={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],a=function(t){try{return i(t)}catch(t){return u.slice()}};t.exports.f=function(t){return u&&"[object Window]"==o.call(t)?a(t):i(r(t))}},function(t,n,e){var r=e(54),i=e(31).concat("length","prototype");n.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n,e){var r=e(28),i=e(24);t.exports=function(t){return function(n,e){var o,u,a=String(i(n)),s=r(e),c=a.length;return s<0||s>=c?t?"":void 0:(o=a.charCodeAt(s),o<55296||o>56319||s+1===c||(u=a.charCodeAt(s+1))<56320||u>57343?t?a.charAt(s):o:t?a.slice(s,s+2):(o-55296<<10)+(u-56320)+65536)}}},function(t,n,e){var r,i,o,u=e(17),a=e(147),s=e(50),c=e(30),f=e(4),l=f.process,h=f.setImmediate,d=f.clearImmediate,v=f.MessageChannel,p=0,y={},m="onreadystatechange",k=function(){var t=+this;if(y.hasOwnProperty(t)){var n=y[t];delete y[t],n()}},g=function(t){k.call(t.data)};h&&d||(h=function(t){for(var n=[],e=1;arguments.length>e;)n.push(arguments[e++]);return y[++p]=function(){a("function"==typeof t?t:Function(t),n)},r(p),p},d=function(t){delete y[t]},"process"==e(18)(l)?r=function(t){l.nextTick(u(k,t,1))}:v?(i=new v,o=i.port2,i.port1.onmessage=g,r=u(o.postMessage,o,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",g,!1)):r=m in c("script")?function(t){s.appendChild(c("script"))[m]=function(){s.removeChild(this),k.call(t)}}:function(t){setTimeout(u(k,t,1),0)}),t.exports={set:h,clear:d}},function(t,n,e){var r=e(28),i=Math.max,o=Math.min;t.exports=function(t,n){return t=r(t),t<0?i(t+n,0):o(t,n)}},function(t,n,e){var r=e(5),i=e(40);t.exports=e(2).getIterator=function(t){var n=i(t);if("function"!=typeof n)throw TypeError(t+" is not iterable!");return r(n.call(t))}},function(t,n,e){"use strict";var r=e(85),i=e(92),o=e(15),u=e(9);t.exports=e(43)(Array,"Array",function(t,n){this._t=u(t),this._i=0,this._k=n},function(){var t=this._t,n=this._k,e=this._i++;return!t||e>=t.length?(this._t=void 0,i(1)):"keys"==n?i(0,e):"values"==n?i(0,t[e]):i(0,[e,t[e]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(t,n,e){var r=e(10);r(r.S+r.F*!e(7),"Object",{defineProperty:e(6).f})},67,function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(111);e.d(n,"a",function(){return c});var s=e(166),c=function(){function t(n){i()(this,t),this.functionLookupTable=n}return u()(t,[{key:"spawn",value:function(){if(!window.Worker)throw new Error("Missing Web Worker support");var t=new s,n=new a.a(t,this.functionLookupTable);return n.initialize(),n}}]),t}()},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(124),s=e(16),c=e(123);e.d(n,"a",function(){return f});var f=function(){function t(){i()(this,t),this.ids=new a.a,this.definitions=new a.a,this.lastId=0}return u()(t,[{key:"getOrSetId",value:function(t){if(e.i(s.b)(t))return t;var n=t.toString(),r=this.ids.get(n);return"undefined"==typeof r&&(r=e.i(s.a)("dynamic",++this.lastId),this.initDefinition(t,r)),r}},{key:"getDefinition",value:function(t){return this.definitions.get(t.identifier)}},{key:"initDefinition",value:function(t,n){var r=t.toString(),i=e.i(c.a)(t),o=r.substring(r.indexOf("(")+1,r.indexOf(")")).split(","),u=r.substring(r.indexOf("{")+1,r.lastIndexOf("}")).trim(),a={argumentNames:o.map(function(t){return t.trim()}),body:u,id:n,name:i?i:void 0};this.ids.set(r,n),this.definitions.set(n.identifier,a)}}]),t}()},function(t,n,e){"use strict";function r(t){function n(n){if(n){if(n.hasOwnProperty("threadPool")&&"undefined"==typeof n.threadPool)throw new Error("The thread pool is mandatory and cannot be unset");if(n.hasOwnProperty("functionCallSerializer")&&"undefined"==typeof n.functionCallSerializer)throw new Error("The function call serializer is mandatory and cannot be unset");e.i(i.a)(n)}return e.i(l.a)({},t,n)}return{defaultOptions:function(r){return r?void(t=n(r)):e.i(l.a)({},t)},from:function(t,r){return e.i(s.a)(new o.a(t),n(r))},range:function(t,r,i,o){var a=u.a.create(t,r,i);return e.i(s.a)(a,n(o))},times:function(t,r,i,o){return i?e.i(s.a)(a.a.create(t,r),n(o),i):e.i(s.a)(a.a.create(t,r),n(o))},run:function(n){for(var r=void 0,i=arguments.length,o=Array(i>1?i-1:0),u=1;u<i;u++)o[u-1]=arguments[u];r=e.i(c.b)(n)?f.a.create(n,o):f.a.create(n,o);var a=t.functionCallSerializer.serializeFunctionCall(r),s={main:a,usedFunctionIds:[a.functionId]};return t.threadPool.run(s)}}}var i=e(45),o=e(64),u=e(116),a=e(117),s=e(113),c=e(16),f=e(12),l=e(74);e.d(n,"a",function(){return r})},function(t,n,e){"use strict";var r=e(47),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a),c=e(79),f=e.n(c),l=e(78),h=e.n(l),d=e(119);e.d(n,"a",function(){return v});var v=function(t){function n(){return u()(this,n),f()(this,(n.__proto__||i()(n)).apply(this,arguments))}return h()(n,t),s()(n,[{key:"getScheduling",value:function(t,n){var e=void 0;e=n.maxDegreeOfParallelism?n.maxDegreeOfParallelism:4*n.threadPool.maxThreads;var r=t/e;return n.minValuesPerTask&&(r=Math.min(Math.max(r,n.minValuesPerTask),t)),n.maxValuesPerTask&&(r=Math.min(r,n.maxValuesPerTask)),r=Math.ceil(r),{numberOfTasks:0===r?0:Math.ceil(t/r),valuesPerTask:r}}}]),n}(d.a)},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(122);e.d(n,"a",function(){return s});var s=function(){function t(n,e){i()(this,t),this.workerThreadFactory=n,this.workers=[],this.idleWorkers=[],this.queue=[],this.maxThreadsLimit=e.maxConcurrencyLevel}return u()(t,[{key:"run",value:function(t){var n=new a.a(t);return this.queue.unshift(n),this.schedulePendingTasks(),n}},{key:"schedulePendingTasks",value:function(){for(;this.queue.length;){var t=void 0;if(0===this.idleWorkers.length&&this.workers.length<this.maxThreadsLimit?(t=this.workerThreadFactory.spawn(),this.workers.push(t)):this.idleWorkers.length>0&&(t=this.idleWorkers.pop()),!t)return;var n=this.queue.pop();this.runTaskOnWorker(n,t)}}},{key:"runTaskOnWorker",value:function(t,n){var e=this;t.isCancellationRequested?(t.resolveCancelled(),this.releaseWorker(n)):n.run(t.definition,function(r,i){r?t.reject(r):t.resolve(i),e.releaseWorker(n)})}},{key:"releaseWorker",value:function(t){this.idleWorkers.push(t),this.schedulePendingTasks()}},{key:"maxThreads",get:function(){return this.maxThreadsLimit},set:function(t){if("number"!=typeof t||t%1!==0||t<=0)throw new Error("The maxThreads limit ("+t+") has to be a positive integer larger than zero.");this.maxThreadsLimit=t}}]),t}()},function(t,n,e){"use strict";var r=e(106),i=e(108),o=e(107),u=e(105),a=e(44),s=e(104),c=e(60);e.d(n,"IParallel",function(){return c.a}),e.d(n,"ITaskDefinition",function(){return c.b}),e.d(n,"ITask",function(){return c.c}),e.d(n,"IFunctionDefinition",function(){return c.d}),e.d(n,"IFunctionId",function(){return c.e}),e.d(n,"isFunctionId",function(){return c.f}),e.d(n,"FunctionCall",function(){return c.g}),e.d(n,"ISerializedFunctionCall",function(){return c.h}),e.d(n,"isSerializedFunctionCall",function(){return c.i}),e.d(n,"FunctionCallSerializer",function(){return c.j}),e.d(n,"IThreadPool",function(){return c.k}),e.d(n,"IParallelChain",function(){return c.l}),e.d(n,"IParallelTaskEnvironment",function(){return c.m}),e.d(n,"IParallelEnvironment",function(){return c.n}),e.d(n,"IParallelJob",function(){return c.o}),e.d(n,"IParallelOptions",function(){return c.p}),e.d(n,"IDefaultInitializedParallelOptions",function(){return c.q}),e.d(n,"IParallelJobScheduler",function(){return c.r}),e.d(n,"IParallelOperation",function(){return c.s}),e.d(n,"ISerializedParallelOperation",function(){return c.t}),e.d(n,"IParallelStream",function(){return c.u});var f=new u.a,l=window.navigator.hardwareConcurrency||4,h=new a.a(f),d=new i.a(new s.a(f),{maxConcurrencyLevel:l}),v=e.i(r.a)({functionCallSerializer:h,scheduler:new o.a,threadPool:d});n.default=v},function(t,n,e){"use strict";var r=e(13),i=e.n(r),o=e(47),u=e.n(o),a=e(79),s=e.n(a),c=e(132),f=e.n(c),l=e(78),h=e.n(l),d=e(0),v=e.n(d),p=e(1),y=e.n(p),m=e(75);e.d(n,"a",function(){return k}),e.d(n,"b",function(){return g});var k=function(){function t(n){v()(this,t),this.name=n}return y()(t,[{key:"onMessage",value:function(t){throw new Error("Browser worker thread in state '"+this.name+"' cannot handle the received message ("+t.data.type+").")}},{key:"onError",value:function(t){console.error("Processing error on worker slave",t.error)}}]),t}(),g=function(t){function n(t,e,r){v()(this,n);var i=s()(this,(n.__proto__||u()(n)).call(this,"executing"));return i.callback=t,i.functionRegistry=e,i.worker=r,i}return h()(n,t),y()(n,[{key:"onMessage",value:function(t){var r=t.data;e.i(m.a)(r)?this.handleFunctionRequest(r):e.i(m.b)(r)?this.callback(void 0,r.result):e.i(m.c)(r)?this.callback(r.error,void 0):f()(n.prototype.__proto__||u()(n.prototype),"onMessage",this).call(this,t)}},{key:"onError",value:function(t){this.callback(t.error,void 0)}},{key:"handleFunctionRequest",value:function(t){var n=[],e=[],r=!0,o=!1,u=void 0;try{for(var a,s=i()(t.functionIds);!(r=(a=s.next()).done);r=!0){var c=a.value,f=this.functionRegistry.getDefinition(c);f?e.push(f):n.push(c)}}catch(t){o=!0,u=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw u}}this.worker.postMessage(m.d.apply(void 0,[e].concat(n)))}}]),n}(k)},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(75),s=e(110);e.d(n,"a",function(){return f});var c=0,f=function(){function t(n,e){i()(this,t),this.worker=n,this.functionLookupTable=e,this.id=++c,this.state=new s.a("default"),this.stopped=!1;var r=this;this.worker.addEventListener("message",function(){r.onWorkerMessage.apply(r,arguments)}),this.worker.addEventListener("error",function(){r.onError.apply(r,arguments)})}return u()(t,[{key:"initialize",value:function(){if("default"!==this.state.name)throw new Error("The browser worker thread can only be initialized if in state default but actual state is '"+this.state.name+"'.");this.sendMessage(e.i(a.e)(this.id)),this.state=new s.a("idle")}},{key:"run",value:function(t,n){var r=this;if("idle"!==this.state.name)throw new Error("The browser worker thread can only execute a new task if in state idle but actual state is '"+this.state.name+"'.");this.sendMessage(e.i(a.f)(t));var i=function(t,e){r.stopped?r.state=new s.a("stopped"):r.state=new s.a("idle"),n(t,e)};this.state=new s.b(i,this.functionLookupTable,this.worker)}},{key:"stop",value:function(){this.stopped||(this.sendMessage(e.i(a.g)()),this.stopped=!0,"executing"!==this.state.name&&(this.state=new s.a("stopped")))}},{key:"toString",value:function(){return"BrowserWorkerThread { id: "+this.id+", state: "+this.state.name}},{key:"onWorkerMessage",value:function(t){this.state.onMessage(t)}},{key:"onError",value:function(t){this.state.onError(t),this.state=new s.a("errored")}},{key:"sendMessage",value:function(t){
this.worker.postMessage(t)}}]),t}()},function(t,n,e){"use strict";var r=e(81),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a),c=e(63),f=e(64),l=e(46),h=e(34);e.d(n,"a",function(){return d});var d=function(){function t(n,e,r){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];u()(this,t),this.previousStream=n,this.options=e,this.environment=r,this.operations=i}return s()(t,[{key:"resolve",value:function t(){var n=this,e=void 0,t=void 0,r=void 0,i=new h.a(function(n,i,o){e=n,t=i,r=o});return this.previousStream.then(function(i){var o=n.options.scheduler.schedule({environment:n.environment,generator:new f.a(i),operations:n.operations,options:n.options}),u=h.a.fromTasks(o,[],l.a);u.subscribe(e,r,t)},r),new c.a(i,this.options,this.environment)}},{key:"chainOperation",value:function(n){return new t(this.previousStream,this.options,this.environment,[].concat(i()(this.operations),[n]))}},{key:"addEnvironment",value:function(n){return new t(this.previousStream,this.options,this.environment.add(n),this.operations)}}]),t}()},function(t,n,e){"use strict";function r(t,n,e){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[],a=void 0;e instanceof Array?(a=void 0,r=e):a=e;var s=new o.a(new i.a(t,n,u.a.of(),r));return a?s.inEnvironment(a):s}var i=e(115),o=e(114),u=e(118);n.a=r},function(t,n,e){"use strict";var r=e(13),i=e.n(r),o=e(80),u=e.n(o),a=e(0),s=e.n(a),c=e(1),f=e.n(c),l=e(23),h=e(12),d=e(34),v=e(16),p=e(33);e.d(n,"a",function(){return y});var y=function(){function t(n){s()(this,t),this.state=n}return f()(t,[{key:"inEnvironment",value:function(n){var r=void 0;if("function"==typeof n||e.i(v.b)(n)){for(var i=arguments.length,o=Array(i>1?i-1:0),u=1;u<i;u++)o[u-1]=arguments[u];r=h.a.createUnchecked.apply(h.a,[n].concat(o))}else r=e.i(p.a)(n)?h.a.fromSerialized(n):n;return new t(this.state.addEnvironment(r))}},{key:"map",value:function(t){return this._chain(h.a.createUnchecked(l.a.MAP),h.a.createUnchecked(t))}},{key:"reduce",value:function(t,n,e){var r=e||n,o=this._chain(h.a.createUnchecked(l.a.REDUCE,t),h.a.createUnchecked(n)).resolveChain();return d.a.transform(o,function(n){if(0===n.length)return t;var e=u()(n),o=e[0],a=e.slice(1),s=o,c=!0,f=!1,l=void 0;try{for(var h,d=i()(a);!(c=(h=d.next()).done);c=!0){var v=h.value;s=r(s,v)}}catch(t){f=!0,l=t}finally{try{!c&&d.return&&d.return()}finally{if(f)throw l}}return s})}},{key:"filter",value:function(t){return this._chain(h.a.createUnchecked(l.a.FILTER),h.a.createUnchecked(t))}},{key:"subscribe",value:function(t,n,e){return this.resolveChain().subscribe(t,n,e)}},{key:"then",value:function(t,n){return this.resolveChain().then(t,n)}},{key:"catch",value:function(t){return this.resolveChain().catch(t)}},{key:"resolveChain",value:function(){var t=this.state=this.state.resolve();return t.stream}},{key:"_chain",value:function(n,e){var r={iterator:n,iteratee:e};return new t(this.state.chainOperation(r))}}]),t}()},function(t,n,e){"use strict";var r=e(81),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a),c=e(63),f=e(34),l=e(46);e.d(n,"a",function(){return h});var h=function(){function t(n,e,r,i){u()(this,t),this.generator=n,this.options=e,this.environment=r,this.operations=i}return s()(t,[{key:"resolve",value:function(){var t=this.options.scheduler.schedule({environment:this.environment,generator:this.generator,operations:this.operations,options:this.options});return new c.a(f.a.fromTasks(t,[],l.a),this.options,this.environment)}},{key:"chainOperation",value:function(n){return new t(this.generator,this.options,this.environment,[].concat(i()(this.operations),[n]))}},{key:"addEnvironment",value:function(n){return new t(this.generator,this.options,this.environment.add(n),this.operations)}}]),t}()},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(23),s=e(12);e.d(n,"a",function(){return c});var c=function(){function t(n,e,r){i()(this,t),this.start=n,this.end=e,this.step=r}return u()(t,[{key:"serializeSlice",value:function(t,n,e){var r=n*this.step,i=this.start+t*r,o=Math.min(i+r,this.end);return e.serializeFunctionCall(s.a.createUnchecked(a.a.RANGE,i,o,this.step))}},{key:"length",get:function(){return Math.ceil((this.end-this.start)/this.step)}}],[{key:"create",value:function(n,e,r){if("undefined"==typeof e&&(e=n,n=0),"undefined"==typeof r&&(r=e<n?-1:1),0===r)throw new Error("Step size of zero is not allowed");return new t(n,e,r)}}]),t}()},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(23),s=e(12),c=e(16);e.d(n,"a",function(){return f});var f=function(){function t(n,e){i()(this,t),this.times=n,this.iteratee=e}return u()(t,[{key:"serializeSlice",value:function(t,n,e){var r=t*n,i=Math.min(r+n,this.times),o=e.serializeFunctionCall(this.iteratee);return e.serializeFunctionCall(s.a.create(a.a.TIMES,r,i,o))}},{key:"length",get:function(){return this.times}}],[{key:"create",value:function(n,r){var i=void 0;return i=e.i(c.b)(r)||"function"==typeof r?s.a.createUnchecked(r):s.a.create(a.a.IDENTITY,r),new t(n,i)}}]),t}()},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(12),s=e(74);e.d(n,"a",function(){return c});var c=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];i()(this,t),this.environments=n}return u()(t,[{key:"add",value:function(n){var r=this.environments.slice();return n instanceof a.a||!(this.environments.length>0)||this.environments[this.environments.length-1]instanceof a.a?r.push(n):r[r.length-1]=e.i(s.a)({},r[r.length-1],n),new t(r)}},{key:"toJSON",value:function(t){return this.environments.map(function(n){return n instanceof a.a?t.serializeFunctionCall(n):n})}}],[{key:"of",value:function(n){var e=t.EMPTY;return n?e.add(n):e}}]),t}();c.EMPTY=new c},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o),a=e(12),s=e(23),c=e(46),f=e(33);e.d(n,"a",function(){return l});var l=function(){function t(){i()(this,t)}return u()(t,[{key:"schedule",value:function(t){var n=this.getTaskDefinitions(t);return n.map(function(n){return t.options.threadPool.run(n)})}},{key:"getTaskDefinitions",value:function(t){var n=this.getScheduling(t.generator.length,t.options),r=t.options.functionCallSerializer,i=t.environment.toJSON(r),o=this.serializeOperations(t.operations,r),u=[s.a.PARALLEL_JOB_EXECUTOR].concat(e.i(c.b)(o.map(function(t){return[t.iteratee.functionId,t.iterator.functionId]})));i.forEach(function(t){e.i(f.a)(t)&&u.push(t.functionId)});for(var l=[],h=0;h<n.numberOfTasks;++h){var d=t.generator.serializeSlice(h,n.valuesPerTask,r),v={environments:i,generator:d,operations:o,taskIndex:h,valuesPerTask:n.valuesPerTask},p={main:r.serializeFunctionCall(a.a.createUnchecked(s.a.PARALLEL_JOB_EXECUTOR,v)),taskIndex:h,usedFunctionIds:[d.functionId].concat(u),valuesPerTask:n.valuesPerTask};l.push(p)}return l}},{key:"serializeOperations",value:function(t,n){return t.map(function(t){return{iteratee:n.serializeFunctionCall(t.iteratee),iterator:n.serializeFunctionCall(t.iterator)}})}}]),t}()},function(t,n,e){"use strict";var r=e(48),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a);e.d(n,"a",function(){return c});var c=function(){function t(n){u()(this,t),this.promise=i.a.resolve(n)}return s()(t,[{key:"subscribe",value:function(t,n,e){return(e||n)&&this.promise.then(e,n),this}},{key:"then",value:function(t,n){return this.promise.then(t,n)}},{key:"catch",value:function(t){return this.promise.catch(t)}}]),t}()},function(t,n,e){"use strict";var r=e(13),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a),c=e(34);e.d(n,"a",function(){return f});var f=function(){function t(n,e,r){var o=this;u()(this,t),this.failed=!1,this.nextSubResultIndex=0,this.tasks=n,this.joiner=r,this.endResult=e,this.pending=n.length,this.subResults=new Array(this.tasks.length),this.innerStream=new c.a(function(t,n,e){o.next=t,o.resolve=n,o.reject=e});var a=!0,s=!1,f=void 0;try{for(var l,h=i()(n);!(a=(l=h.next()).done);a=!0){var d=l.value;this.registerTaskHandler(d)}}catch(t){s=!0,f=t}finally{try{!a&&h.return&&h.return()}finally{if(s)throw f}}}return s()(t,[{key:"subscribe",value:function(t,n,e){return this.innerStream.subscribe(t,n,e),this}},{key:"then",value:function(t,n){return this.innerStream.then(t,n)}},{key:"catch",value:function(t){return this.innerStream.catch(t)}},{key:"registerTaskHandler",value:function(t){var n=this;t.then(function(e){return n._taskCompleted(e,t.definition)},function(t){return n._taskFailed(t)})}},{key:"_taskCompleted",value:function(t,n){if(0===this.pending)throw new Error("Stream already resolved but taskCompleted called one more time");--this.pending,this.tasks[n.taskIndex]=void 0,this.subResults[n.taskIndex]=t,this.failed||(this.next(t,n.taskIndex,n.valuesPerTask),this.nextSubResultIndex===n.taskIndex&&this.joinSubResults(),0===this.pending&&(this.resolve(this.endResult),this.endResult=void 0))}},{key:"joinSubResults",value:function(){for(;this.nextSubResultIndex<this.subResults.length&&"undefined"!=typeof this.subResults[this.nextSubResultIndex];){var t=this.subResults[this.nextSubResultIndex];this.subResults[this.nextSubResultIndex]=void 0,this.endResult=this.joiner.apply(void 0,[this.endResult,t]),++this.nextSubResultIndex}}},{key:"_taskFailed",value:function(t){if(this.failed!==!0){this.failed=!0;var n=!0,e=!1,r=void 0;try{for(var o,u=i()(this.tasks);!(n=(o=u.next()).done);n=!0){var a=o.value;"undefined"!=typeof a&&a.cancel()}}catch(t){e=!0,r=t}finally{try{!n&&u.return&&u.return()}finally{if(e)throw r}}this.reject(t)}}}]),t}()},function(t,n,e){"use strict";var r=e(48),i=e.n(r),o=e(0),u=e.n(o),a=e(1),s=e.n(a);e.d(n,"a",function(){return c});var c=function(){function t(n){var e=this;u()(this,t),this.definition=n,this.isCancellationRequested=!1,this.isCanceled=!1,this.promise=new i.a(function(t,n){e.resolvePromise=t,e.rejectPromise=n})}return s()(t,[{key:"resolve",value:function(t){this.isCancellationRequested?this.resolveCancelled():this.resolvePromise(t)}},{key:"resolveCancelled",value:function(){this.isCanceled=!0,this.reject("Task has been canceled")}},{key:"reject",value:function(t){this.rejectPromise(t)}},{key:"then",value:function(t,n){return n?this.promise.then(t,n):this.promise.then(t)}},{key:"catch",value:function(t){return this.promise.catch(t)}},{key:"cancel",value:function(){this.isCancellationRequested=!0}}]),t}()},function(t,n,e){"use strict";function r(t){if(t.hasOwnProperty("name"))return t.name;var n=t.toString(),e=n.indexOf("function");return e===-1?"":n.substring(e+8,n.indexOf("(")).trim()}n.a=r},function(t,n,e){"use strict";var r=e(0),i=e.n(r),o=e(1),u=e.n(o);e.d(n,"a",function(){return a});var a=function(){function t(){i()(this,t),this.data={}}return u()(t,[{key:"get",value:function(t){var n=this.toInternalKey(t);return this.has(t)?this.data[n]:void 0}},{key:"has",value:function(t){return this.hasOwnProperty.call(this.data,this.toInternalKey(t))}},{key:"set",value:function(t,n){this.data[this.toInternalKey(t)]=n}},{key:"clear",value:function(){this.data={}}},{key:"toInternalKey",value:function(t){return"@"+t}}]),t}()},function(t,n,e){t.exports={default:e(134),__esModule:!0}},function(t,n,e){t.exports={default:e(135),__esModule:!0}},function(t,n,e){t.exports={default:e(136),__esModule:!0}},function(t,n,e){t.exports={default:e(137),__esModule:!0}},function(t,n,e){t.exports={default:e(139),__esModule:!0}},function(t,n,e){t.exports={default:e(141),__esModule:!0}},function(t,n,e){t.exports={default:e(142),__esModule:!0}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var i=e(47),o=r(i),u=e(127),a=r(u);n.default=function t(n,e,r){null===n&&(n=Function.prototype);var i=(0,a.default)(n,e);if(void 0===i){var u=(0,o.default)(n);return null===u?void 0:t(u,e,r)}if("value"in i)return i.value;var s=i.get;if(void 0!==s)return s.call(r)}},function(t,n,e){e(29),e(156),t.exports=e(2).Array.from},function(t,n,e){var r=e(2),i=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return i.stringify.apply(i,arguments)}},function(t,n,e){e(157);var r=e(2).Object;t.exports=function(t,n){return r.create(t,n)}},function(t,n,e){e(158);var r=e(2).Object;t.exports=function(t,n){return r.getOwnPropertyDescriptor(t,n)}},function(t,n,e){e(159);var r=e(2).Object;t.exports=function(t){return r.getOwnPropertyNames(t)}},function(t,n,e){e(160),t.exports=e(2).Object.getPrototypeOf},function(t,n,e){e(161),t.exports=e(2).Object.setPrototypeOf},function(t,n,e){e(103),e(29),e(41),e(162),t.exports=e(2).Promise},function(t,n,e){e(163),e(103),e(164),e(165),t.exports=e(2).Symbol},function(t,n,e){e(29),e(41),t.exports=e(59).f("iterator")},function(t,n){t.exports=function(t,n,e,r){if(!(t instanceof n)||void 0!==r&&r in t)throw TypeError(e+": incorrect invocation!");return t}},function(t,n,e){"use strict";var r=e(6),i=e(20);t.exports=function(t,n,e){n in t?r.f(t,n,i(0,e)):t[n]=e}},function(t,n,e){var r=e(26),i=e(96),o=e(55);t.exports=function(t){var n=r(t),e=i.f;if(e)for(var u,a=e(t),s=o.f,c=0;a.length>c;)s.call(t,u=a[c++])&&n.push(u);return n}},function(t,n,e){var r=e(17),i=e(89),o=e(88),u=e(5),a=e(37),s=e(40),c={},f={},n=t.exports=function(t,n,e,l,h){var d,v,p,y,m=h?function(){return t}:s(t),k=r(e,l,n?2:1),g=0;if("function"!=typeof m)throw TypeError(t+" is not iterable!");if(o(m)){for(d=a(t.length);d>g;g++)if(y=n?k(u(v=t[g])[0],v[1]):k(t[g]),y===c||y===f)return y}else for(p=m.call(t);!(v=p.next()).done;)if(y=i(p,k,v.value,n),y===c||y===f)return y};n.BREAK=c,n.RETURN=f},function(t,n){t.exports=function(t,n,e){var r=void 0===e;switch(n.length){case 0:return r?t():t.call(e);case 1:return r?t(n[0]):t.call(e,n[0]);case 2:return r?t(n[0],n[1]):t.call(e,n[0],n[1]);case 3:return r?t(n[0],n[1],n[2]):t.call(e,n[0],n[1],n[2]);case 4:return r?t(n[0],n[1],n[2],n[3]):t.call(e,n[0],n[1],n[2],n[3])}return t.apply(e,n)}},function(t,n,e){var r=e(18);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,n,e){var r=e(26),i=e(9);t.exports=function(t,n){for(var e,o=i(t),u=r(o),a=u.length,s=0;a>s;)if(o[e=u[s++]]===n)return e}},function(t,n,e){var r=e(22)("meta"),i=e(14),o=e(11),u=e(6).f,a=0,s=Object.isExtensible||function(){return!0},c=!e(19)(function(){return s(Object.preventExtensions({}))}),f=function(t){u(t,r,{value:{i:"O"+ ++a,w:{}}})},l=function(t,n){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!o(t,r)){if(!s(t))return"F";if(!n)return"E";f(t)}return t[r].i},h=function(t,n){if(!o(t,r)){if(!s(t))return!0;if(!n)return!1;f(t)}return t[r].w},d=function(t){return c&&v.NEED&&s(t)&&!o(t,r)&&f(t),t},v=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:h,onFreeze:d}},function(t,n,e){var r=e(4),i=e(98).set,o=r.MutationObserver||r.WebKitMutationObserver,u=r.process,a=r.Promise,s="process"==e(18)(u);t.exports=function(){var t,n,e,c=function(){var r,i;for(s&&(r=u.domain)&&r.exit();t;){i=t.fn,t=t.next;try{i()}catch(r){throw t?e():n=void 0,r}}n=void 0,r&&r.enter()};if(s)e=function(){u.nextTick(c)};else if(o){var f=!0,l=document.createTextNode("");new o(c).observe(l,{characterData:!0}),e=function(){l.data=f=!f}}else if(a&&a.resolve){var h=a.resolve();e=function(){h.then(c)}}else e=function(){i.call(r,c)};return function(r){var i={fn:r,next:void 0};n&&(n.next=i),t||(t=i,e()),n=i}}},function(t,n,e){var r=e(8);t.exports=function(t,n,e){for(var i in n)e&&t[i]?t[i]=n[i]:r(t,i,n[i]);return t}},function(t,n,e){var r=e(14),i=e(5),o=function(t,n){if(i(t),!r(n)&&null!==n)throw TypeError(n+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,n,r){try{r=e(17)(Function.call,e(52).f(Object.prototype,"__proto__").set,2),r(t,[]),n=!(t instanceof Array)}catch(t){n=!0}return function(t,e){return o(t,e),n?t.__proto__=e:r(t,e),t}}({},!1):void 0),check:o}},function(t,n,e){"use strict";var r=e(4),i=e(2),o=e(6),u=e(7),a=e(3)("species");t.exports=function(t){var n="function"==typeof i[t]?i[t]:r[t];u&&n&&!n[a]&&o.f(n,a,{configurable:!0,get:function(){return this}})}},function(t,n,e){var r=e(5),i=e(35),o=e(3)("species");t.exports=function(t,n){var e,u=r(t).constructor;return void 0===u||void 0==(e=r(u)[o])?n:i(e)}},function(t,n,e){"use strict";var r=e(17),i=e(10),o=e(38),u=e(89),a=e(88),s=e(37),c=e(144),f=e(40);i(i.S+i.F*!e(91)(function(t){Array.from(t)}),"Array",{from:function(t){var n,e,i,l,h=o(t),d="function"==typeof this?this:Array,v=arguments.length,p=v>1?arguments[1]:void 0,y=void 0!==p,m=0,k=f(h);if(y&&(p=r(p,v>2?arguments[2]:void 0,2)),void 0==k||d==Array&&a(k))for(n=s(h.length),e=new d(n);n>m;m++)c(e,m,y?p(h[m],m):h[m]);else for(l=k.call(h),e=new d;!(i=l.next()).done;m++)c(e,m,y?u(l,p,[i.value,m],!0):i.value);return e.length=m,e}})},function(t,n,e){var r=e(10);r(r.S,"Object",{create:e(36)})},function(t,n,e){var r=e(9),i=e(52).f;e(56)("getOwnPropertyDescriptor",function(){return function(t,n){return i(r(t),n)}})},function(t,n,e){e(56)("getOwnPropertyNames",function(){return e(94).f})},function(t,n,e){var r=e(38),i=e(53);e(56)("getPrototypeOf",function(){return function(t){return i(r(t))}})},function(t,n,e){var r=e(10);r(r.S,"Object",{setPrototypeOf:e(153).set})},function(t,n,e){"use strict";var r,i,o,u=e(25),a=e(4),s=e(17),c=e(49),f=e(10),l=e(14),h=e(35),d=e(143),v=e(146),p=e(155),y=e(98).set,m=e(151)(),k="Promise",g=a.TypeError,b=a.process,_=a[k],b=a.process,w="process"==c(b),x=function(){},O=!!function(){try{var t=_.resolve(1),n=(t.constructor={})[e(3)("species")]=function(t){t(x,x)};return(w||"function"==typeof PromiseRejectionEvent)&&t.then(x)instanceof n}catch(t){}}(),P=function(t,n){return t===n||t===_&&n===o},S=function(t){var n;return!(!l(t)||"function"!=typeof(n=t.then))&&n},I=function(t){return P(_,t)?new T(t):new i(t)},T=i=function(t){var n,e;this.promise=new t(function(t,r){if(void 0!==n||void 0!==e)throw g("Bad Promise constructor");n=t,e=r}),this.resolve=h(n),this.reject=h(e)},E=function(t){try{t()}catch(t){return{error:t}}},j=function(t,n){if(!t._n){t._n=!0;var e=t._c;m(function(){for(var r=t._v,i=1==t._s,o=0,u=function(n){var e,o,u=i?n.ok:n.fail,a=n.resolve,s=n.reject,c=n.domain;try{u?(i||(2==t._h&&R(t),t._h=1),u===!0?e=r:(c&&c.enter(),e=u(r),c&&c.exit()),e===n.promise?s(g("Promise-chain cycle")):(o=S(e))?o.call(e,a,s):a(e)):s(r)}catch(t){s(t)}};e.length>o;)u(e[o++]);t._c=[],t._n=!1,n&&!t._h&&M(t)})}},M=function(t){y.call(a,function(){var n,e,r,i=t._v;if(F(t)&&(n=E(function(){w?b.emit("unhandledRejection",i,t):(e=a.onunhandledrejection)?e({promise:t,reason:i}):(r=a.console)&&r.error&&r.error("Unhandled promise rejection",i)}),t._h=w||F(t)?2:1),t._a=void 0,n)throw n.error})},F=function(t){if(1==t._h)return!1;for(var n,e=t._a||t._c,r=0;e.length>r;)if(n=e[r++],n.fail||!F(n.promise))return!1;return!0},R=function(t){y.call(a,function(){var n;w?b.emit("rejectionHandled",t):(n=a.onrejectionhandled)&&n({promise:t,reason:t._v})})},C=function(t){var n=this;n._d||(n._d=!0,n=n._w||n,n._v=t,n._s=2,n._a||(n._a=n._c.slice()),j(n,!0))},A=function(t){var n,e=this;if(!e._d){e._d=!0,e=e._w||e;try{if(e===t)throw g("Promise can't be resolved itself");(n=S(t))?m(function(){var r={_w:e,_d:!1};try{n.call(t,s(A,r,1),s(C,r,1))}catch(t){C.call(r,t)}}):(e._v=t,e._s=1,j(e,!1))}catch(t){C.call({_w:e,_d:!1},t)}}};O||(_=function(t){d(this,_,k,"_h"),h(t),r.call(this);try{t(s(A,this,1),s(C,this,1))}catch(t){C.call(this,t)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=e(152)(_.prototype,{then:function(t,n){var e=I(p(this,_));return e.ok="function"!=typeof t||t,e.fail="function"==typeof n&&n,e.domain=w?b.domain:void 0,this._c.push(e),this._a&&this._a.push(e),this._s&&j(this,!1),e.promise},catch:function(t){return this.then(void 0,t)}}),T=function(){var t=new r;this.promise=t,this.resolve=s(A,t,1),this.reject=s(C,t,1)}),f(f.G+f.W+f.F*!O,{Promise:_}),e(21)(_,k),e(154)(k),o=e(2)[k],f(f.S+f.F*!O,k,{reject:function(t){var n=I(this),e=n.reject;return e(t),n.promise}}),f(f.S+f.F*(u||!O),k,{resolve:function(t){if(t instanceof _&&P(t.constructor,this))return t;var n=I(this),e=n.resolve;return e(t),n.promise}}),f(f.S+f.F*!(O&&e(91)(function(t){_.all(t).catch(x)})),k,{all:function(t){var n=this,e=I(n),r=e.resolve,i=e.reject,o=E(function(){var e=[],o=0,u=1;v(t,!1,function(t){var a=o++,s=!1;e.push(void 0),u++,n.resolve(t).then(function(t){s||(s=!0,e[a]=t,--u||r(e))},i)}),--u||r(e)});return o&&i(o.error),e.promise},race:function(t){var n=this,e=I(n),r=e.reject,i=E(function(){v(t,!1,function(t){n.resolve(t).then(e.resolve,r)})});return i&&r(i.error),e.promise}})},function(t,n,e){"use strict";var r=e(4),i=e(11),o=e(7),u=e(10),a=e(57),s=e(150).KEY,c=e(19),f=e(32),l=e(21),h=e(22),d=e(3),v=e(59),p=e(58),y=e(149),m=e(145),k=e(148),g=e(5),b=e(9),_=e(39),w=e(20),x=e(36),O=e(94),P=e(52),S=e(6),I=e(26),T=P.f,E=S.f,j=O.f,M=r.Symbol,F=r.JSON,R=F&&F.stringify,C="prototype",A=d("_hidden"),z=d("toPrimitive"),L={}.propertyIsEnumerable,W=f("symbol-registry"),D=f("symbols"),N=f("op-symbols"),U=Object[C],J="function"==typeof M,q=r.QObject,V=!q||!q[C]||!q[C].findChild,B=o&&c(function(){return 7!=x(E({},"a",{get:function(){return E(this,"a",{value:7}).a}})).a})?function(t,n,e){var r=T(U,n);r&&delete U[n],E(t,n,e),r&&t!==U&&E(U,n,r)}:E,K=function(t){var n=D[t]=x(M[C]);return n._k=t,n},G=J&&"symbol"==typeof M.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof M},H=function(t,n,e){return t===U&&H(N,n,e),g(t),n=_(n,!0),g(e),i(D,n)?(e.enumerable?(i(t,A)&&t[A][n]&&(t[A][n]=!1),e=x(e,{enumerable:w(0,!1)})):(i(t,A)||E(t,A,w(1,{})),t[A][n]=!0),B(t,n,e)):E(t,n,e)},Y=function(t,n){g(t);for(var e,r=m(n=b(n)),i=0,o=r.length;o>i;)H(t,e=r[i++],n[e]);return t},X=function(t,n){return void 0===n?x(t):Y(x(t),n)},Q=function(t){var n=L.call(this,t=_(t,!0));return!(this===U&&i(D,t)&&!i(N,t))&&(!(n||!i(this,t)||!i(D,t)||i(this,A)&&this[A][t])||n)},Z=function(t,n){if(t=b(t),n=_(n,!0),t!==U||!i(D,n)||i(N,n)){var e=T(t,n);return!e||!i(D,n)||i(t,A)&&t[A][n]||(e.enumerable=!0),e}},$=function(t){for(var n,e=j(b(t)),r=[],o=0;e.length>o;)i(D,n=e[o++])||n==A||n==s||r.push(n);return r},tt=function(t){for(var n,e=t===U,r=j(e?N:b(t)),o=[],u=0;r.length>u;)!i(D,n=r[u++])||e&&!i(U,n)||o.push(D[n]);return o};J||(M=function(){if(this instanceof M)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),n=function(e){this===U&&n.call(N,e),i(this,A)&&i(this[A],t)&&(this[A][t]=!1),B(this,t,w(1,e))};return o&&V&&B(U,t,{configurable:!0,set:n}),K(t)},a(M[C],"toString",function(){return this._k}),P.f=Z,S.f=H,e(95).f=O.f=$,e(55).f=Q,e(96).f=tt,o&&!e(25)&&a(U,"propertyIsEnumerable",Q,!0),v.f=function(t){return K(d(t))}),u(u.G+u.W+u.F*!J,{Symbol:M});for(var nt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),et=0;nt.length>et;)d(nt[et++]);for(var nt=I(d.store),et=0;nt.length>et;)p(nt[et++]);u(u.S+u.F*!J,"Symbol",{for:function(t){return i(W,t+="")?W[t]:W[t]=M(t)},keyFor:function(t){if(G(t))return y(W,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!J,"Object",{create:X,defineProperty:H,defineProperties:Y,getOwnPropertyDescriptor:Z,getOwnPropertyNames:$,getOwnPropertySymbols:tt}),F&&u(u.S+u.F*(!J||c(function(){var t=M();return"[null]"!=R([t])||"{}"!=R({a:t})||"{}"!=R(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!G(t)){for(var n,e,r=[t],i=1;arguments.length>i;)r.push(arguments[i++]);return n=r[1],"function"==typeof n&&(e=n),!e&&k(n)||(n=function(t,n){if(e&&(n=e.call(this,t,n)),!G(n))return n}),r[1]=n,R.apply(F,r)}}}),M[C][z]||e(8)(M[C],z,M[C].valueOf),l(M,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,n,e){e(58)("asyncIterator")},function(t,n,e){e(58)("observable")},function(t,n,e){t.exports=function(){return new Worker(e.p+"worker-slave.parallel.js")}},,function(t,n,e){var r=e(109).default;t.exports=r}]))});


/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;
exports.Pool = exports.defaults = exports.config = undefined;
exports.spawn = spawn;

__webpack_require__(32);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _defaults = __webpack_require__(19);

var _defaults2 = _interopRequireDefault(_defaults);

var _pool = __webpack_require__(37);

var _pool2 = _interopRequireDefault(_pool);

var _worker = __webpack_require__(41);

var _worker2 = _interopRequireDefault(_worker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.config = _config2.default;
exports.defaults = _defaults2.default;
exports.Pool = _pool2.default;
function spawn() {
  var runnable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var importScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return new _worker2.default(runnable, importScripts);
}

exports.default = {
  config: _config2.default,
  defaults: _defaults2.default,
  Pool: _pool2.default,
  spawn: spawn,
  Worker: _worker2.default
};
//# sourceMappingURL=index.js.map


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ },
/* 5 */
/***/ function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* unused harmony export knightTours */
/* harmony export (immutable) */ exports["a"] = parallelKnightTours;

function knightTours(startPath, _ref) {
    var boardSize = _ref.boardSize;

    var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
    var board = new Array(boardSize * boardSize);
    board.fill(0);
    function visitField(field, n) {
        if (n === board.length) {
            return 1;
        }
        var result = 0;
        var fieldIndex = field.x * boardSize + field.y;
        board[fieldIndex] = n;
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: field.x + move.x, y: field.y + move.y };
            // not outside of board and not yet accessed
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && board[successor.x * boardSize + successor.y] === 0;
            if (accessible) {
                result += visitField(successor, n + 1);
            }
        }
        board[fieldIndex] = 0;
        return result;
    }
    for (var index = 0; index < startPath.length - 1; ++index) {
        var fieldIndex = startPath[index].x * boardSize + startPath[index].y;
        board[fieldIndex] = index + 1;
    }
    return visitField(startPath[startPath.length - 1], startPath.length);
}
function parallelKnightTours(start, boardSize) {
    function successors(coordinate) {
        var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
        var result = [];
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: coordinate.x + move.x, y: coordinate.y + move.y };
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && (successor.x !== start.x || successor.y !== start.y) && successor.x !== coordinate.x && successor.y !== coordinate.y;
            if (accessible) {
                result.push(successor);
            }
        }
        return result;
    }
    function computeStartFields() {
        var result = [];
        for (var _iterator = successors(start), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var directSuccessor = _ref2;

            for (var _iterator2 = successors(directSuccessor), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref3 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref3 = _i2.value;
                }

                var indirectSuccessor = _ref3;

                result.push([start, directSuccessor, indirectSuccessor]);
            }
        }
        return result;
    }
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.from(computeStartFields()).inEnvironment({ boardSize: boardSize }).map(knightTours).reduce(0, function (memo, count) {
        return memo + count;
    });
}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* harmony export (immutable) */ exports["a"] = createMandelOptions;
/* unused harmony export computeMandelbrotLine */
/* harmony export (immutable) */ exports["c"] = parallelMandelbrot;
/* harmony export (immutable) */ exports["b"] = syncMandelbrot;

function createMandelOptions(imageWidth, imageHeight, iterations) {
    // X axis shows real numbers, y axis imaginary
    var min = { i: -1.2, real: -2.0 };
    var max = { i: 0, real: 1.0 };
    max.i = min.i + (max.real - min.real) * imageHeight / imageWidth;
    var scalingFactor = {
        i: (max.i - min.i) / (imageHeight - 1),
        real: (max.real - min.real) / (imageWidth - 1)
    };
    return {
        imageHeight: imageHeight,
        imageWidth: imageWidth,
        iterations: iterations,
        max: max,
        min: min,
        scalingFactor: scalingFactor
    };
}
function computeMandelbrotLine(y, options) {
    function calculateZ(c) {
        var z = { i: c.i, real: c.real };
        var n = 0;
        for (; n < options.iterations; ++n) {
            if (Math.pow(z.real, 2) + Math.pow(z.i, 2) > 4) {
                break;
            }
            // z ** 2 + c
            var zI = z.i;
            z.i = 2 * z.real * z.i + c.i;
            z.real = Math.pow(z.real, 2) - Math.pow(zI, 2) + c.real;
        }
        return n;
    }
    var line = new Uint8ClampedArray(options.imageWidth * 4);
    var cI = options.max.i - y * options.scalingFactor.i;
    for (var x = 0; x < options.imageWidth; ++x) {
        var c = {
            i: cI,
            real: options.min.real + x * options.scalingFactor.real
        };
        var n = calculateZ(c);
        var base = x * 4;
        /* tslint:disable:no-bitwise */
        line[base] = n & 0xFF;
        line[base + 1] = n & 0xFF00;
        line[base + 2] = n & 0xFF0000;
        line[base + 3] = 255;
    }
    return line;
}
function parallelMandelbrot(mandelbrotOptions, options) {
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.range(0, mandelbrotOptions.imageHeight, 1, options).inEnvironment(mandelbrotOptions).map(computeMandelbrotLine);
}
function syncMandelbrot(mandelbrotOptions, callback) {
    for (var y = 0; y < mandelbrotOptions.imageHeight; ++y) {
        var line = computeMandelbrotLine(y, mandelbrotOptions);
        callback(line, y);
    }
}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* harmony export (immutable) */ exports["a"] = syncMonteCarlo;
/* harmony export (immutable) */ exports["b"] = parallelMonteCarlo;

function initializeOptions(options) {
    return Object.assign({}, {
        investmentAmount: 1000000,
        liquidity: 10000,
        numRuns: 10000,
        numYears: 10,
        performance: 0,
        projects: [],
        seed: undefined,
        volatility: 0.01
    }, options);
}
function createMonteCarloEnvironment(options, taskEnvironment) {
    function toAbsoluteIndices(indices, cashFlows) {
        var absolute = new Array(indices.length);
        var currentPortfolioValue = options.investmentAmount;
        var previousYearIndex = 100;
        for (var relativeYear = 0; relativeYear < indices.length; ++relativeYear) {
            var currentYearIndex = indices[relativeYear];
            var cashFlowStartOfYear = relativeYear === 0 ? 0 : cashFlows[relativeYear - 1];
            // scale current value with performance gain according to index
            var performance = currentYearIndex / previousYearIndex;
            currentPortfolioValue = (currentPortfolioValue + cashFlowStartOfYear) * performance;
            absolute[relativeYear] = Math.round(currentPortfolioValue);
            previousYearIndex = currentYearIndex;
        }
        return absolute;
    }
    function simulateSingleAbsoluteOutcome(numYears, cashFlows) {
        var indices = new Array(numYears + 1);
        indices[0] = 100;
        for (var i = 0; i < numYears; ++i) {
            var randomPerformance = 1 + Math.random();
            indices[i + 1] = indices[i] * randomPerformance;
        }
        // convert the relative values from above to absolute values.
        return toAbsoluteIndices(indices, cashFlows);
    }
    /**
     * Performs the monte carlo simulation for all years and num runs.
     * @param cashFlows the cash flows
     * @param numYears the number of years to simulate
     * @returns {number[][]} the simulated outcomes grouped by year
     */
    function simulateOutcomes(cashFlows, numYears) {
        var result = new Array(numYears);
        for (var year = 0; year <= numYears; ++year) {
            result[year] = new Array(options.numRuns);
        }
        for (var run = 0; run < options.numRuns; ++run) {
            var indices = simulateSingleAbsoluteOutcome(numYears, cashFlows);
            for (var _year = 0; _year < indices.length; ++_year) {
                result[_year][run] = indices[_year];
            }
        }
        return result;
    }
    function projectsToCashFlows(numYears) {
        var cashFlows = [];
        for (var year = 0; year < numYears; ++year) {
            var projectsByThisYear = projectsByStartYear[year] || [];
            var cashFlow = -projectsByThisYear.reduce(function (memo, project) {
                return memo + project.totalAmount;
            }, 0);
            cashFlows.push(cashFlow);
        }
        return cashFlows;
    }
    function calculateNoInterestReferenceLine(cashFlows, numYears) {
        var noInterestReferenceLine = [];
        var investmentAmountLeft = options.investmentAmount;
        for (var year = 0; year < numYears; ++year) {
            investmentAmountLeft = investmentAmountLeft + cashFlows[year];
            noInterestReferenceLine.push(investmentAmountLeft);
        }
        return noInterestReferenceLine;
    }
    var projectsToSimulate = options.projects;
    if (taskEnvironment) {
        projectsToSimulate = options.projects.slice(taskEnvironment.taskIndex * taskEnvironment.valuesPerTask, (taskEnvironment.taskIndex + 1) * taskEnvironment.valuesPerTask);
    }
    var projects = options.projects.sort(function (a, b) {
        return a.startYear - b.startYear;
    });
    // Group projects by startYear, use lodash groupBy instead
    var projectsByStartYear = {};
    for (var _iterator = projects, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var project = _ref;

        var arr = projectsByStartYear[project.startYear] = projectsByStartYear[project.startYear] || [];
        arr.push(project);
    }
    var numYears = projectsToSimulate.reduce(function (memo, project) {
        return Math.max(memo, project.startYear);
    }, 0);
    var cashFlows = projectsToCashFlows(numYears);
    var noInterestReferenceLine = calculateNoInterestReferenceLine(cashFlows, numYears);
    return {
        investmentAmount: options.investmentAmount,
        liquidity: options.liquidity,
        noInterestReferenceLine: noInterestReferenceLine,
        numRuns: options.numRuns,
        numYears: numYears,
        projectsByStartYear: projectsByStartYear,
        simulatedValues: simulateOutcomes(cashFlows, numYears)
    };
}
function calculateProject(project, environment) {
    function groupForValue(value, groups) {
        return groups.find(function (group) {
            return (typeof group.from === "undefined" || group.from <= value) && (typeof group.to === "undefined" || group.to > value);
        });
    }
    function createGroups(requiredAmount, noInterestReference) {
        return [{ description: "Ziel erreichbar", from: requiredAmount, name: "green", percentage: 0, separator: true }, { description: "mit Zusatzliquidität erreichbar", from: requiredAmount - environment.liquidity, name: "yellow", percentage: 0, separator: true, to: requiredAmount }, { description: "nicht erreichbar", from: noInterestReference, name: "gray", percentage: 0, separator: false, to: requiredAmount - environment.liquidity }, { description: "nicht erreichbar, mit Verlust", name: "red", percentage: 0, separator: false, to: noInterestReference }];
    }
    function calculateRequiredAmount() {
        var amount = project.totalAmount;
        var projectsSameYear = environment.projectsByStartYear[project.startYear];
        for (var _iterator2 = projectsSameYear, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var otherProject = _ref2;

            if (otherProject === project) {
                break;
            }
            amount += otherProject.totalAmount;
        }
        return amount;
    }
    function median(values) {
        var half = Math.floor(values.length / 2);
        if (values.length % 2) {
            return values[half];
        }
        return (values[half - 1] + values[half]) / 2.0;
    }
    function computeBucket(bucketStart, bucketSize, simulatedValuesThisYear, groups, valuesByGroup) {
        var bucket = {
            max: Number.MIN_SAFE_INTEGER,
            min: Number.MAX_SAFE_INTEGER,
            // Needed to avoid deoptimization because of changed attribute orders in subBuckets. Initialize with const order
            subBuckets: {
                green: {
                    group: "green",
                    max: Number.MIN_SAFE_INTEGER,
                    min: Number.MAX_SAFE_INTEGER,
                    empty: true
                },
                yellow: {
                    group: "yellow",
                    max: Number.MIN_SAFE_INTEGER,
                    min: Number.MAX_SAFE_INTEGER,
                    empty: true
                },
                gray: {
                    group: "gray",
                    max: Number.MIN_SAFE_INTEGER,
                    min: Number.MAX_SAFE_INTEGER,
                    empty: true
                },
                red: {
                    group: "red",
                    max: Number.MIN_SAFE_INTEGER,
                    min: Number.MAX_SAFE_INTEGER,
                    empty: true
                }
            }
        };
        var bucketEnd = bucketStart + bucketSize;
        for (var j = bucketStart; j < bucketEnd; ++j) {
            var value = simulatedValuesThisYear[j];
            bucket.min = Math.min(bucket.min, value);
            bucket.max = Math.max(bucket.max, value);
            var group = groupForValue(simulatedValuesThisYear[j], groups);
            valuesByGroup[group.name] = ++valuesByGroup[group.name];
            var subBucket = bucket.subBuckets[group.name];
            subBucket.min = Math.min(subBucket.min, value);
            subBucket.max = Math.max(subBucket.max, value);
            subBucket.empty = false;
        }
        return bucket;
    }
    function computeBuckets(groups, simulatedValuesThisYear) {
        var NUMBER_OF_BUCKETS = 10;
        var valuesByGroup = {
            green: 0,
            yellow: 0,
            gray: 0,
            red: 0
        };
        var bucketSize = Math.round(simulatedValuesThisYear.length / NUMBER_OF_BUCKETS);
        var buckets = [];
        for (var i = 0; i < simulatedValuesThisYear.length; i += bucketSize) {
            var bucket = computeBucket(i, bucketSize, simulatedValuesThisYear, groups, valuesByGroup);
            buckets.push(bucket);
        }
        return { buckets: buckets, valuesByGroup: valuesByGroup };
    }
    var requiredAmount = calculateRequiredAmount();
    var simulatedValuesThisYear = environment.simulatedValues[project.startYear];
    simulatedValuesThisYear.sort(function (a, b) {
        return a - b;
    });
    var groups = createGroups(requiredAmount, environment.noInterestReferenceLine[project.startYear]);

    var _computeBuckets = computeBuckets(groups, simulatedValuesThisYear),
        buckets = _computeBuckets.buckets,
        valuesByGroup = _computeBuckets.valuesByGroup;

    var nonEmptyGroups = groups.filter(function (group) {
        return !!valuesByGroup[group.name];
    });
    nonEmptyGroups.forEach(function (group) {
        return group.percentage = valuesByGroup[group.name] / simulatedValuesThisYear.length;
    });
    var oneSixth = Math.round(simulatedValuesThisYear.length / 6);
    return {
        buckets: buckets,
        groups: nonEmptyGroups,
        max: simulatedValuesThisYear[simulatedValuesThisYear.length - 1],
        median: median(simulatedValuesThisYear),
        min: simulatedValuesThisYear[0],
        project: project,
        twoThird: {
            max: simulatedValuesThisYear[simulatedValuesThisYear.length - oneSixth],
            min: simulatedValuesThisYear[oneSixth]
        }
    };
}
function syncMonteCarlo(options) {
    var environment = createMonteCarloEnvironment(initializeOptions(options));
    var projects = [];
    for (var _iterator3 = options.projects, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }

        var project = _ref3;

        projects.push(calculateProject(project, environment));
    }
    return projects;
}
function parallelMonteCarlo(userOptions) {
    var options = initializeOptions(userOptions);
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.from(options.projects, { minValuesPerTask: 2, maxDegreeOfParallelism: __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.defaultOptions().threadPool.maxThreads }).inEnvironment(createMonteCarloEnvironment, options).map(calculateProject);
}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* unused harmony export knightTours */
/* harmony export (immutable) */ exports["a"] = threadsKnightTours;
function knightTours(_ref, done) {
    var boardSize = _ref.boardSize,
        startPath = _ref.startPath;

    var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
    var board = new Array(boardSize * boardSize);
    board.fill(0);
    function visitField(field, n) {
        if (n === board.length) {
            return 1;
        }
        var result = 0;
        var fieldIndex = field.x * boardSize + field.y;
        board[fieldIndex] = n;
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: field.x + move.x, y: field.y + move.y };
            // not outside of board and not yet accessed
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && board[successor.x * boardSize + successor.y] === 0;
            if (accessible) {
                result += visitField(successor, n + 1);
            }
        }
        board[fieldIndex] = 0;
        return result;
    }
    for (var index = 0; index < startPath.length - 1; ++index) {
        var fieldIndex = startPath[index].x * boardSize + startPath[index].y;
        board[fieldIndex] = index + 1;
    }
    var result = visitField(startPath[startPath.length - 1], startPath.length);
    done(result);
}
function threadsKnightTours(start, boardSize, pool) {
    function successors(coordinate) {
        var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
        var result = [];
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: coordinate.x + move.x, y: coordinate.y + move.y };
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && (successor.x !== start.x || successor.y !== start.y) && successor.x !== coordinate.x && successor.y !== coordinate.y;
            if (accessible) {
                result.push(successor);
            }
        }
        return result;
    }
    function computeStartFields() {
        var result = [];
        for (var _iterator = successors(start), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var directSuccessor = _ref2;

            for (var _iterator2 = successors(directSuccessor), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref3 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref3 = _i2.value;
                }

                var indirectSuccessor = _ref3;

                result.push([start, directSuccessor, indirectSuccessor]);
            }
        }
        return result;
    }
    var resolve = void 0;
    var reject = void 0;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    var totalTours = 0;
    pool.run(knightTours).on("done", function (job, tours) {
        return totalTours += tours;
    }).on("finished", function () {
        resolve(totalTours);
    });
    for (var _iterator3 = computeStartFields(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref4 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref4 = _i3.value;
        }

        var startPath = _ref4;

        pool.send({ startPath: startPath, boardSize: boardSize });
    }
    return promise;
}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* unused harmony export knightTours */
/* harmony export (immutable) */ exports["b"] = syncKnightTours;
/* harmony export (immutable) */ exports["a"] = parallelKnightTours;

function knightTours(startPath, _ref) {
    var boardSize = _ref.boardSize;

    var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
    var board = new Array(boardSize * boardSize);
    board.fill(0);
    function visitField(field, n) {
        if (n === board.length) {
            return 1;
        }
        var result = 0;
        var fieldIndex = field.x * boardSize + field.y;
        board[fieldIndex] = n;
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: field.x + move.x, y: field.y + move.y };
            // not outside of board and not yet accessed
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && board[successor.x * boardSize + successor.y] === 0;
            if (accessible) {
                result += visitField(successor, n + 1);
            }
        }
        board[fieldIndex] = 0;
        return result;
    }
    for (var index = 0; index < startPath.length - 1; ++index) {
        var fieldIndex = startPath[index].x * boardSize + startPath[index].y;
        board[fieldIndex] = index + 1;
    }
    return visitField(startPath[startPath.length - 1], startPath.length);
}
function syncKnightTours(start, boardSize) {
    return knightTours([start], { boardSize: boardSize });
}
function parallelKnightTours(start, boardSize) {
    function successors(coordinate) {
        var moves = [{ x: -2, y: -1 }, { x: -2, y: 1 }, { x: -1, y: -2 }, { x: -1, y: 2 }, { x: 1, y: -2 }, { x: 1, y: 2 }, { x: 2, y: -1 }, { x: 2, y: 1 }];
        var result = [];
        for (var i = 0; i < moves.length; ++i) {
            var move = moves[i];
            var successor = { x: coordinate.x + move.x, y: coordinate.y + move.y };
            var accessible = successor.x >= 0 && successor.y >= 0 && successor.x < boardSize && successor.y < boardSize && (successor.x !== start.x || successor.y !== start.y) && successor.x !== coordinate.x && successor.y !== coordinate.y;
            if (accessible) {
                result.push(successor);
            }
        }
        return result;
    }
    function computeStartFields() {
        var result = [];
        for (var _iterator = successors(start), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var directSuccessor = _ref2;

            for (var _iterator2 = successors(directSuccessor), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref3 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref3 = _i2.value;
                }

                var indirectSuccessor = _ref3;

                result.push([start, directSuccessor, indirectSuccessor]);
            }
        }
        return result;
    }
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.from(computeStartFields()).inEnvironment({ boardSize: boardSize }).map({
        identifier: "static:/home/travis/build/MichaReiser/parallel-es-example/src/transpiled/knights-tour.ts/knightTours",
        _______isFunctionId: true
    }).reduce(0, {
        identifier: "static:/home/travis/build/MichaReiser/parallel-es-example/src/transpiled/knights-tour.ts/_anonymous",
        _______isFunctionId: true
    }, function (memo, count) {
        return memo + count;
    });
}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* harmony export (immutable) */ exports["a"] = mandelbrot;

function mandelbrot(_ref, options) {
    var imageWidth = _ref.imageWidth,
        imageHeight = _ref.imageHeight,
        iterations = _ref.iterations;

    // X axis shows real numbers, y axis imaginary
    var min = { i: -1.2, real: -2.0 };
    var max = { i: 0, real: 1.0 };
    max.i = min.i + (max.real - min.real) * imageHeight / imageWidth;
    var scalingFactor = {
        i: (max.i - min.i) / (imageHeight - 1),
        real: (max.real - min.real) / (imageWidth - 1)
    };

    function _environmentExtractor() {
        return {
            iterations: iterations,
            imageWidth: imageWidth,
            max: max,
            scalingFactor: scalingFactor,
            min: min
        };
    }

    function computeMandelbrotLine(y) {
        // Function inline is up to 30% faster than if the function is not inline
        // https://jsperf.com/mandelbrot-env3 https://jsperf.com/mandelbrot-env4
        function calculateZ(c) {
            var z = { i: c.i, real: c.real };
            var n = 0;
            for (; n < iterations; ++n) {
                if (Math.pow(z.real, 2) + Math.pow(z.i, 2) > 4) {
                    break;
                }
                // z ** 2 + c
                var zI = z.i;
                z.i = 2 * z.real * z.i + c.i;
                z.real = Math.pow(z.real, 2) - Math.pow(zI, 2) + c.real;
            }
            return n;
        }
        var line = new Uint8ClampedArray(imageWidth * 4);
        var cI = max.i - y * scalingFactor.i;
        for (var x = 0; x < imageWidth; ++x) {
            var c = {
                i: cI,
                real: min.real + x * scalingFactor.real
            };
            var n = calculateZ(c);
            var base = x * 4;
            /* tslint:disable:no-bitwise */
            line[base] = n & 0xFF;
            line[base + 1] = n & 0xFF00;
            line[base + 2] = n & 0xFF0000;
            line[base + 3] = 255;
        }
        return line;
    }
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.range(0, imageHeight, 1, options).inEnvironment(_environmentExtractor()).map({
        identifier: "static:/home/travis/build/MichaReiser/parallel-es-example/src/transpiled/mandelbrot.ts/_entry_computeMandelbrotLin",
        _______isFunctionId: true
    });
}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parallel_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parallel_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simjs_random__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simjs_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simjs_random__);
/* harmony export (immutable) */ exports["b"] = syncMonteCarlo;
/* harmony export (immutable) */ exports["a"] = parallelMonteCarlo;


function initializeOptions(options) {
    return Object.assign({}, {
        investmentAmount: 1000000,
        liquidity: 10000,
        numRuns: 10000,
        numYears: 10,
        performance: 0,
        projects: [],
        seed: undefined,
        volatility: 0.01
    }, options);
}
function toAbsoluteIndices(indices, cashFlows, investmentAmount) {
    var absolute = new Array(indices.length);
    var currentPortfolioValue = investmentAmount;
    var previousYearIndex = 100;
    for (var relativeYear = 0; relativeYear < indices.length; ++relativeYear) {
        var currentYearIndex = indices[relativeYear];
        var cashFlowStartOfYear = relativeYear === 0 ? 0 : cashFlows[relativeYear - 1];
        // scale current value with performance gain according to index
        var performance = currentYearIndex / previousYearIndex;
        currentPortfolioValue = (currentPortfolioValue + cashFlowStartOfYear) * performance;
        absolute[relativeYear] = Math.round(currentPortfolioValue);
        previousYearIndex = currentYearIndex;
    }
    return absolute;
}
function simulateSingleAbsoluteOutcome(numYears, cashFlows, options, random) {
    var indices = new Array(numYears + 1);
    indices[0] = 100;
    for (var i = 0; i < numYears; ++i) {
        var randomPerformance = 1 + random.normal(options.performance, options.volatility);
        indices[i + 1] = indices[i] * randomPerformance;
    }
    // convert the relative values from above to absolute values.
    return toAbsoluteIndices(indices, cashFlows, options.investmentAmount);
}
/**
 * Performs the monte carlo simulation for all years and num runs.
 * @param cashFlows the cash flows
 * @param numYears the number of years to simulate
 * @returns {number[][]} the simulated outcomes grouped by year
 */
function simulateOutcomes(cashFlows, numYears, options) {
    var random = new __WEBPACK_IMPORTED_MODULE_1_simjs_random___default.a(10);
    var result = new Array(numYears);
    for (var year = 0; year <= numYears; ++year) {
        result[year] = new Array(options.numRuns);
    }
    for (var run = 0; run < options.numRuns; ++run) {
        var indices = simulateSingleAbsoluteOutcome(numYears, cashFlows, options, random);
        for (var _year = 0; _year < indices.length; ++_year) {
            result[_year][run] = indices[_year];
        }
    }
    return result;
}
function createMonteCarloEnvironment(options, taskEnvironment) {
    function projectsToCashFlows(numYears) {
        var cashFlows = [];
        for (var year = 0; year < numYears; ++year) {
            var projectsByThisYear = projectsByStartYear[year] || [];
            var cashFlow = -projectsByThisYear.reduce(function (memo, project) {
                return memo + project.totalAmount;
            }, 0);
            cashFlows.push(cashFlow);
        }
        return cashFlows;
    }
    function calculateNoInterestReferenceLine(cashFlows, numYears) {
        var noInterestReferenceLine = [];
        var investmentAmountLeft = options.investmentAmount;
        for (var year = 0; year < numYears; ++year) {
            investmentAmountLeft = investmentAmountLeft + cashFlows[year];
            noInterestReferenceLine.push(investmentAmountLeft);
        }
        return noInterestReferenceLine;
    }
    var projectsToSimulate = options.projects;
    if (taskEnvironment) {
        projectsToSimulate = options.projects.slice(taskEnvironment.taskIndex * taskEnvironment.valuesPerTask, (taskEnvironment.taskIndex + 1) * taskEnvironment.valuesPerTask);
    }
    var projects = options.projects.sort(function (a, b) {
        return a.startYear - b.startYear;
    });
    // Group projects by startYear, use lodash groupBy instead
    var projectsByStartYear = {};
    for (var _iterator = projects, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var project = _ref;

        var arr = projectsByStartYear[project.startYear] = projectsByStartYear[project.startYear] || [];
        arr.push(project);
    }
    var numYears = projectsToSimulate.reduce(function (memo, project) {
        return Math.max(memo, project.startYear);
    }, 0);
    var cashFlows = projectsToCashFlows(numYears);
    var noInterestReferenceLine = calculateNoInterestReferenceLine(cashFlows, numYears);
    return {
        investmentAmount: options.investmentAmount,
        liquidity: options.liquidity,
        noInterestReferenceLine: noInterestReferenceLine,
        numRuns: options.numRuns,
        numYears: numYears,
        projectsByStartYear: projectsByStartYear,
        simulatedValues: simulateOutcomes(cashFlows, numYears, options)
    };
}
function groupForValue(value, groups) {
    return groups.find(function (group) {
        return (typeof group.from === "undefined" || group.from <= value) && (typeof group.to === "undefined" || group.to > value);
    });
}
function createGroups(requiredAmount, noInterestReference, environment) {
    return [{ description: "Ziel erreichbar", from: requiredAmount, name: "green", percentage: 0, separator: true }, { description: "mit Zusatzliquidität erreichbar", from: requiredAmount - environment.liquidity, name: "yellow", percentage: 0, separator: true, to: requiredAmount }, { description: "nicht erreichbar", from: noInterestReference, name: "gray", percentage: 0, separator: false, to: requiredAmount - environment.liquidity }, { description: "nicht erreichbar, mit Verlust", name: "red", percentage: 0, separator: false, to: noInterestReference }];
}
function calculateRequiredAmount(project, environment) {
    var amount = project.totalAmount;
    var projectsSameYear = environment.projectsByStartYear[project.startYear];
    for (var _iterator2 = projectsSameYear, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var otherProject = _ref2;

        if (otherProject === project) {
            break;
        }
        amount += otherProject.totalAmount;
    }
    return amount;
}
function median(values) {
    var half = Math.floor(values.length / 2);
    if (values.length % 2) {
        return values[half];
    }
    return (values[half - 1] + values[half]) / 2.0;
}
function computeBucket(bucketStart, bucketSize, simulatedValuesThisYear, groups, valuesByGroup) {
    var bucket = {
        max: Number.MIN_SAFE_INTEGER,
        min: Number.MAX_SAFE_INTEGER,
        // Needed to avoid deoptimization because of changed attribute orders in subBuckets. Initialize with const order
        subBuckets: {
            green: {
                group: "green",
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
                empty: true
            },
            yellow: {
                group: "yellow",
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
                empty: true
            },
            gray: {
                group: "gray",
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
                empty: true
            },
            red: {
                group: "red",
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
                empty: true
            }
        }
    };
    var bucketEnd = bucketStart + bucketSize;
    for (var j = bucketStart; j < bucketEnd; ++j) {
        var value = simulatedValuesThisYear[j];
        bucket.min = Math.min(bucket.min, value);
        bucket.max = Math.max(bucket.max, value);
        var group = groupForValue(simulatedValuesThisYear[j], groups);
        ++valuesByGroup[group.name];
        var subBucket = bucket.subBuckets[group.name];
        subBucket.min = Math.min(subBucket.min, value);
        subBucket.max = Math.max(subBucket.max, value);
        subBucket.empty = false;
    }
    return bucket;
}
function computeBuckets(groups, simulatedValuesThisYear) {
    var NUMBER_OF_BUCKETS = 10;
    var valuesByGroup = {
        green: 0,
        yellow: 0,
        gray: 0,
        red: 0
    };
    var bucketSize = Math.round(simulatedValuesThisYear.length / NUMBER_OF_BUCKETS);
    var buckets = [];
    for (var i = 0; i < simulatedValuesThisYear.length; i += bucketSize) {
        var bucket = computeBucket(i, bucketSize, simulatedValuesThisYear, groups, valuesByGroup);
        buckets.push(bucket);
    }
    return { buckets: buckets, valuesByGroup: valuesByGroup };
}
function compareNumbersInverse(a, b) {
    return a - b;
}
function calculateProject(project, environment) {
    var requiredAmount = calculateRequiredAmount(project, environment);
    var simulatedValuesThisYear = environment.simulatedValues[project.startYear];
    simulatedValuesThisYear.sort(compareNumbersInverse);
    var groups = createGroups(requiredAmount, environment.noInterestReferenceLine[project.startYear], environment);

    var _computeBuckets = computeBuckets(groups, simulatedValuesThisYear),
        buckets = _computeBuckets.buckets,
        valuesByGroup = _computeBuckets.valuesByGroup;

    var nonEmptyGroups = groups.filter(function (group) {
        return !!valuesByGroup[group.name];
    });
    nonEmptyGroups.forEach(function (group) {
        return group.percentage = valuesByGroup[group.name] / simulatedValuesThisYear.length;
    });
    var oneSixth = Math.round(simulatedValuesThisYear.length / 6);
    return {
        buckets: buckets,
        groups: nonEmptyGroups,
        max: simulatedValuesThisYear[simulatedValuesThisYear.length - 1],
        median: median(simulatedValuesThisYear),
        min: simulatedValuesThisYear[0],
        project: project,
        twoThird: {
            max: simulatedValuesThisYear[simulatedValuesThisYear.length - oneSixth],
            min: simulatedValuesThisYear[oneSixth]
        }
    };
}
function syncMonteCarlo(options) {
    var environment = createMonteCarloEnvironment(initializeOptions(options));
    var projects = [];
    for (var _iterator3 = options.projects, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }

        var project = _ref3;

        projects.push(calculateProject(project, environment));
    }
    return projects;
}
function parallelMonteCarlo(userOptions) {
    var options = initializeOptions(userOptions);
    return __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.from(options.projects, { minValuesPerTask: 2, maxDegreeOfParallelism: __WEBPACK_IMPORTED_MODULE_0_parallel_es___default.a.defaultOptions().threadPool.maxThreads }).inEnvironment({
        functionId: {
            identifier: "static:/home/travis/build/MichaReiser/parallel-es-example/src/transpiled/monte-carlo.ts/createMonteCarloEnvironment",
            _______isFunctionId: true
        },
        parameters: [options],
        ______serializedFunctionCall: true
    }).map({
        identifier: "static:/home/travis/build/MichaReiser/parallel-es-example/src/transpiled/monte-carlo.ts/calculateProject",
        _______isFunctionId: true
    });
}

/***/ },
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports) {

"use strict";
'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getConfig = getConfig;
exports.setConfig = setConfig;
var configuration = {
  basepath: {
    node: '',
    web: ''
  },
  fallback: {
    slaveScriptUrl: ''
  }
};

function configDeepMerge(destObj, srcObj) {
  var ancestorProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  Object.keys(srcObj).forEach(function (propKey) {
    var srcValue = srcObj[propKey];
    var ancestorPropsAndThis = ancestorProps.concat([propKey]);

    if ((typeof srcValue === 'undefined' ? 'undefined' : _typeof(srcValue)) === 'object') {
      if (typeof destObj[propKey] !== 'undefined' && _typeof(destObj[propKey]) !== 'object') {
        throw new Error('Expected config property not to be an object: ' + ancestorPropsAndThis.join('.'));
      }
      configDeepMerge(destObj[propKey], srcValue, ancestorPropsAndThis);
    } else {
      if (_typeof(destObj[propKey]) === 'object') {
        throw new Error('Expected config property to be an object: ' + ancestorPropsAndThis.join('.'));
      }
      destObj[propKey] = srcValue;
    }
  });
}

var config = {
  get: function get() {
    return configuration;
  },

  set: function set(newConfig) {
    if ((typeof newConfig === 'undefined' ? 'undefined' : _typeof(newConfig)) !== 'object') {
      throw new Error('Expected config object.');
    }

    configDeepMerge(configuration, newConfig);
  }
};

exports.default = config;
function getConfig() {
  return config.get();
}

function setConfig() {
  return config.set.apply(config, arguments);
}
//# sourceMappingURL=config.js.map


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(5).nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16).setImmediate, __webpack_require__(16).clearImmediate))

/***/ },
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {'use strict';

/*eslint-env node*/
/*
 * This file is only a stub to make './defaults' resolve the './defaults.node' module.
 * Loading the browser defaults into the browser bundle is done in the gulpfile by
 * configuring a browserify override.
 */

if (typeof process !== 'undefined' && 'pid' in process) {
  module.exports = __webpack_require__(35);
} else {
  module.exports = __webpack_require__(34);
}
//# sourceMappingURL=defaults.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name,context,definition){
	// special form of UMD for polyfilling across evironments
	context[name] = context[name] || definition();
	if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
	else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = function $AMD$(){ return context[name]; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
})("Promise",typeof global != "undefined" ? global : this,function DEF(){
	/*jshint validthis:true */
	"use strict";

	var builtInProp, cycle, scheduling_queue,
		ToString = Object.prototype.toString,
		timer = (typeof setImmediate != "undefined") ?
			function timer(fn) { return setImmediate(fn); } :
			setTimeout
	;

	// dammit, IE8.
	try {
		Object.defineProperty({},"x",{});
		builtInProp = function builtInProp(obj,name,val,config) {
			return Object.defineProperty(obj,name,{
				value: val,
				writable: true,
				configurable: config !== false
			});
		};
	}
	catch (err) {
		builtInProp = function builtInProp(obj,name,val) {
			obj[name] = val;
			return obj;
		};
	}

	// Note: using a queue instead of array for efficiency
	scheduling_queue = (function Queue() {
		var first, last, item;

		function Item(fn,self) {
			this.fn = fn;
			this.self = self;
			this.next = void 0;
		}

		return {
			add: function add(fn,self) {
				item = new Item(fn,self);
				if (last) {
					last.next = item;
				}
				else {
					first = item;
				}
				last = item;
				item = void 0;
			},
			drain: function drain() {
				var f = first;
				first = last = cycle = void 0;

				while (f) {
					f.fn.call(f.self);
					f = f.next;
				}
			}
		};
	})();

	function schedule(fn,self) {
		scheduling_queue.add(fn,self);
		if (!cycle) {
			cycle = timer(scheduling_queue.drain);
		}
	}

	// promise duck typing
	function isThenable(o) {
		var _then, o_type = typeof o;

		if (o != null &&
			(
				o_type == "object" || o_type == "function"
			)
		) {
			_then = o.then;
		}
		return typeof _then == "function" ? _then : false;
	}

	function notify() {
		for (var i=0; i<this.chain.length; i++) {
			notifyIsolated(
				this,
				(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
				this.chain[i]
			);
		}
		this.chain.length = 0;
	}

	// NOTE: This is a separate function to isolate
	// the `try..catch` so that other code can be
	// optimized better
	function notifyIsolated(self,cb,chain) {
		var ret, _then;
		try {
			if (cb === false) {
				chain.reject(self.msg);
			}
			else {
				if (cb === true) {
					ret = self.msg;
				}
				else {
					ret = cb.call(void 0,self.msg);
				}

				if (ret === chain.promise) {
					chain.reject(TypeError("Promise-chain cycle"));
				}
				else if (_then = isThenable(ret)) {
					_then.call(ret,chain.resolve,chain.reject);
				}
				else {
					chain.resolve(ret);
				}
			}
		}
		catch (err) {
			chain.reject(err);
		}
	}

	function resolve(msg) {
		var _then, self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		try {
			if (_then = isThenable(msg)) {
				schedule(function(){
					var def_wrapper = new MakeDefWrapper(self);
					try {
						_then.call(msg,
							function $resolve$(){ resolve.apply(def_wrapper,arguments); },
							function $reject$(){ reject.apply(def_wrapper,arguments); }
						);
					}
					catch (err) {
						reject.call(def_wrapper,err);
					}
				})
			}
			else {
				self.msg = msg;
				self.state = 1;
				if (self.chain.length > 0) {
					schedule(notify,self);
				}
			}
		}
		catch (err) {
			reject.call(new MakeDefWrapper(self),err);
		}
	}

	function reject(msg) {
		var self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		self.msg = msg;
		self.state = 2;
		if (self.chain.length > 0) {
			schedule(notify,self);
		}
	}

	function iteratePromises(Constructor,arr,resolver,rejecter) {
		for (var idx=0; idx<arr.length; idx++) {
			(function IIFE(idx){
				Constructor.resolve(arr[idx])
				.then(
					function $resolver$(msg){
						resolver(idx,msg);
					},
					rejecter
				);
			})(idx);
		}
	}

	function MakeDefWrapper(self) {
		this.def = self;
		this.triggered = false;
	}

	function MakeDef(self) {
		this.promise = self;
		this.state = 0;
		this.triggered = false;
		this.chain = [];
		this.msg = void 0;
	}

	function Promise(executor) {
		if (typeof executor != "function") {
			throw TypeError("Not a function");
		}

		if (this.__NPO__ !== 0) {
			throw TypeError("Not a promise");
		}

		// instance shadowing the inherited "brand"
		// to signal an already "initialized" promise
		this.__NPO__ = 1;

		var def = new MakeDef(this);

		this["then"] = function then(success,failure) {
			var o = {
				success: typeof success == "function" ? success : true,
				failure: typeof failure == "function" ? failure : false
			};
			// Note: `then(..)` itself can be borrowed to be used against
			// a different promise constructor for making the chained promise,
			// by substituting a different `this` binding.
			o.promise = new this.constructor(function extractChain(resolve,reject) {
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}

				o.resolve = resolve;
				o.reject = reject;
			});
			def.chain.push(o);

			if (def.state !== 0) {
				schedule(notify,def);
			}

			return o.promise;
		};
		this["catch"] = function $catch$(failure) {
			return this.then(void 0,failure);
		};

		try {
			executor.call(
				void 0,
				function publicResolve(msg){
					resolve.call(def,msg);
				},
				function publicReject(msg) {
					reject.call(def,msg);
				}
			);
		}
		catch (err) {
			reject.call(def,err);
		}
	}

	var PromisePrototype = builtInProp({},"constructor",Promise,
		/*configurable=*/false
	);

	// Note: Android 4 cannot use `Object.defineProperty(..)` here
	Promise.prototype = PromisePrototype;

	// built-in "brand" to signal an "uninitialized" promise
	builtInProp(PromisePrototype,"__NPO__",0,
		/*configurable=*/false
	);

	builtInProp(Promise,"resolve",function Promise$resolve(msg) {
		var Constructor = this;

		// spec mandated checks
		// note: best "isPromise" check that's practical for now
		if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
			return msg;
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			resolve(msg);
		});
	});

	builtInProp(Promise,"reject",function Promise$reject(msg) {
		return new this(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			reject(msg);
		});
	});

	builtInProp(Promise,"all",function Promise$all(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}
		if (arr.length === 0) {
			return Constructor.resolve([]);
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			var len = arr.length, msgs = Array(len), count = 0;

			iteratePromises(Constructor,arr,function resolver(idx,msg) {
				msgs[idx] = msg;
				if (++count === len) {
					resolve(msgs);
				}
			},reject);
		});
	});

	builtInProp(Promise,"race",function Promise$race(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			iteratePromises(Constructor,arr,function resolver(idx,msg){
				resolve(msg);
			},reject);
		});
	});

	return Promise;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(16).setImmediate))

/***/ },
/* 33 */
/***/ function(module, exports) {

/*!
 * Random.js version 0.2.6
 * curl http://simjs.com/_downloads/random-0.26-debug.js
 */

 /** Random.js library.
 *
 * The code is licensed as LGPL.
*/

/*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_genrand(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
 */

var Random = function(seed) {
	seed = (seed === undefined) ? (new Date()).getTime() : seed;
	if (typeof(seed) !== 'number'                             // ARG_CHECK
		|| Math.ceil(seed) != Math.floor(seed)) {             // ARG_CHECK
		throw new TypeError("seed value must be an integer"); // ARG_CHECK
	}                                                         // ARG_CHECK


	/* Period parameters */
	this.N = 624;
	this.M = 397;
	this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	this.LOWER_MASK = 0x7fffffff; /* least significant r bits */

	this.mt = new Array(this.N); /* the array for the state vector */
	this.mti=this.N+1; /* mti==N+1 means mt[N] is not initialized */

	//this.init_genrand(seed);
	this.init_by_array([seed], 1);
};

/* initializes mt[N] with a seed */
Random.prototype.init_genrand = function(s) {
	this.mt[0] = s >>> 0;
	for (this.mti=1; this.mti<this.N; this.mti++) {
		var s = this.mt[this.mti-1] ^ (this.mt[this.mti-1] >>> 30);
		this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253)
		+ this.mti;
		/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
		/* In the previous versions, MSBs of the seed affect   */
		/* only MSBs of the array mt[].                        */
		/* 2002/01/09 modified by Makoto Matsumoto             */
		this.mt[this.mti] >>>= 0;
		/* for >32 bit machines */
	}
};

/* initialize by an array with array-length */
/* init_key is the array for initializing keys */
/* key_length is its length */
/* slight change for C++, 2004/2/26 */
Random.prototype.init_by_array = function(init_key, key_length) {
	var i, j, k;
	this.init_genrand(19650218);
	i=1; j=0;
	k = (this.N>key_length ? this.N : key_length);
	for (; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525)))
		+ init_key[j] + j; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++; j++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
		if (j>=key_length) j=0;
	}
	for (k=this.N-1; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941))
		- i; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
	}

	this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
};

/* generates a random number on [0,0xffffffff]-interval */
Random.prototype.genrand_int32 = function() {
	var y;
	var mag01 = new Array(0x0, this.MATRIX_A);
	/* mag01[x] = x * MATRIX_A  for x=0,1 */

	if (this.mti >= this.N) { /* generate N words at one time */
		var kk;

		if (this.mti == this.N+1)   /* if init_genrand() has not been called, */
			this.init_genrand(5489); /* a default initial seed is used */

		for (kk=0;kk<this.N-this.M;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		for (;kk<this.N-1;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+(this.M-this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		y = (this.mt[this.N-1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
		this.mt[this.N-1] = this.mt[this.M-1] ^ (y >>> 1) ^ mag01[y & 0x1];

		this.mti = 0;
	}

	y = this.mt[this.mti++];

	/* Tempering */
	y ^= (y >>> 11);
	y ^= (y << 7) & 0x9d2c5680;
	y ^= (y << 15) & 0xefc60000;
	y ^= (y >>> 18);

	return y >>> 0;
};

/* generates a random number on [0,0x7fffffff]-interval */
Random.prototype.genrand_int31 = function() {
	return (this.genrand_int32()>>>1);
};

/* generates a random number on [0,1]-real-interval */
Random.prototype.genrand_real1 = function() {
	return this.genrand_int32()*(1.0/4294967295.0);
	/* divided by 2^32-1 */
};

/* generates a random number on [0,1)-real-interval */
Random.prototype.random = function() {
	if (this.pythonCompatibility) {
		if (this.skip) {
			this.genrand_int32();
		}
		this.skip = true;
	}
	return this.genrand_int32()*(1.0/4294967296.0);
	/* divided by 2^32 */
};

/* generates a random number on (0,1)-real-interval */
Random.prototype.genrand_real3 = function() {
	return (this.genrand_int32() + 0.5)*(1.0/4294967296.0);
	/* divided by 2^32 */
};

/* generates a random number on [0,1) with 53-bit resolution*/
Random.prototype.genrand_res53 = function() {
	var a=this.genrand_int32()>>>5, b=this.genrand_int32()>>>6;
	return(a*67108864.0+b)*(1.0/9007199254740992.0);
};

/* These real versions are due to Isaku Wada, 2002/01/09 added */


/**************************************************************************/
Random.prototype.LOG4 = Math.log(4.0);
Random.prototype.SG_MAGICCONST = 1.0 + Math.log(4.5);

Random.prototype.exponential = function (lambda) {
	if (arguments.length != 1) {                         // ARG_CHECK
		throw new SyntaxError("exponential() must "     // ARG_CHECK
				+ " be called with 'lambda' parameter"); // ARG_CHECK
	}                                                   // ARG_CHECK

	var r = this.random();
	return -Math.log(r) / lambda;
};

Random.prototype.gamma = function (alpha, beta) {
	if (arguments.length != 2) {                         // ARG_CHECK
		throw new SyntaxError("gamma() must be called"  // ARG_CHECK
				+ " with alpha and beta parameters"); // ARG_CHECK
	}                                                   // ARG_CHECK

	/* Based on Python 2.6 source code of random.py.
	 */

	if (alpha > 1.0) {
		var ainv = Math.sqrt(2.0 * alpha - 1.0);
		var bbb = alpha - this.LOG4;
		var ccc = alpha + ainv;

		while (true) {
			var u1 = this.random();
			if ((u1 < 1e-7) || (u > 0.9999999)) {
				continue;
			}
			var u2 = 1.0 - this.random();
			var v = Math.log(u1 / (1.0 - u1)) / ainv;
			var x = alpha * Math.exp(v);
			var z = u1 * u1 * u2;
			var r = bbb + ccc * v - x;
			if ((r + this.SG_MAGICCONST - 4.5 * z >= 0.0) || (r >= Math.log(z))) {
				return x * beta;
			}
		}
	} else if (alpha == 1.0) {
		var u = this.random();
		while (u <= 1e-7) {
			u = this.random();
		}
		return - Math.log(u) * beta;
	} else {
		while (true) {
			var u = this.random();
			var b = (Math.E + alpha) / Math.E;
			var p = b * u;
			if (p <= 1.0) {
				var x = Math.pow(p, 1.0 / alpha);
			} else {
				var x = - Math.log((b - p) / alpha);
			}
			var u1 = this.random();
			if (p > 1.0) {
				if (u1 <= Math.pow(x, (alpha - 1.0))) {
					break;
				}
			} else if (u1 <= Math.exp(-x)) {
				break;
			}
		}
		return x * beta;
	}

};

Random.prototype.normal = function (mu, sigma) {
	if (arguments.length != 2) {                          // ARG_CHECK
		throw new SyntaxError("normal() must be called"  // ARG_CHECK
				+ " with mu and sigma parameters");      // ARG_CHECK
	}                                                    // ARG_CHECK

	var z = this.lastNormal;
	this.lastNormal = NaN;
	if (!z) {
		var a = this.random() * 2 * Math.PI;
		var b = Math.sqrt(-2.0 * Math.log(1.0 - this.random()));
		z = Math.cos(a) * b;
		this.lastNormal = Math.sin(a) * b;
	}
	return mu + z * sigma;
};

Random.prototype.pareto = function (alpha) {
	if (arguments.length != 1) {                         // ARG_CHECK
		throw new SyntaxError("pareto() must be called" // ARG_CHECK
				+ " with alpha parameter");             // ARG_CHECK
	}                                                   // ARG_CHECK

	var u = this.random();
	return 1.0 / Math.pow((1 - u), 1.0 / alpha);
};

Random.prototype.triangular = function (lower, upper, mode) {
	// http://en.wikipedia.org/wiki/Triangular_distribution
	if (arguments.length != 3) {                         // ARG_CHECK
		throw new SyntaxError("triangular() must be called" // ARG_CHECK
		+ " with lower, upper and mode parameters");    // ARG_CHECK
	}                                                   // ARG_CHECK

	var c = (mode - lower) / (upper - lower);
	var u = this.random();

	if (u <= c) {
		return lower + Math.sqrt(u * (upper - lower) * (mode - lower));
	} else {
		return upper - Math.sqrt((1 - u) * (upper - lower) * (upper - mode));
	}
};

Random.prototype.uniform = function (lower, upper) {
	if (arguments.length != 2) {                         // ARG_CHECK
		throw new SyntaxError("uniform() must be called" // ARG_CHECK
		+ " with lower and upper parameters");    // ARG_CHECK
	}                                                   // ARG_CHECK
	return lower + this.random() * (upper - lower);
};

Random.prototype.weibull = function (alpha, beta) {
	if (arguments.length != 2) {                         // ARG_CHECK
		throw new SyntaxError("weibull() must be called" // ARG_CHECK
		+ " with alpha and beta parameters");    // ARG_CHECK
	}                                                   // ARG_CHECK
	var u = 1.0 - this.random();
	return alpha * Math.pow(-Math.log(u), 1.0 / beta);
};

module.exports = Random;

/***/ },
/* 34 */
/***/ function(module, exports) {

"use strict";
"use strict";

exports.__esModule = true;
/*eslint-env browser*/

exports.default = {
  pool: {
    size: navigator.hardwareConcurrency || 8
  }
};
//# sourceMappingURL=defaults.browser.js.map


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;

var _os = __webpack_require__(43);

exports.default = {
  pool: {
    size: (0, _os.cpus)().length
  }
};
//# sourceMappingURL=defaults.node.js.map


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;

var _eventemitter = __webpack_require__(4);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Job = function (_EventEmitter) {
  _inherits(Job, _EventEmitter);

  function Job(pool) {
    _classCallCheck(this, Job);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.pool = pool;
    _this.thread = null;

    _this.runArgs = [];
    _this.sendArgs = [];

    pool.emit('newJob', _this);
    return _this;
  }

  Job.prototype.run = function run() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 0) {
      throw new Error('Cannot call .run() without arguments.');
    }

    this.runArgs = args;
    return this;
  };

  Job.prototype.send = function send() {
    if (this.runArgs.length === 0) {
      throw new Error('Cannot .send() before .run().');
    }

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    this.sendArgs = args;

    this.emit('readyToRun');
    return this;
  };

  Job.prototype.executeOn = function executeOn(thread) {
    var _thread$once$once$run, _thread$once$once;

    (_thread$once$once$run = (_thread$once$once = thread.once('message', this.emit.bind(this, 'done')).once('error', this.emit.bind(this, 'error'))).run.apply(_thread$once$once, this.runArgs)).send.apply(_thread$once$once$run, this.sendArgs);

    this.thread = thread;

    this.emit('threadChanged');
    return this;
  };

  Job.prototype.promise = function promise() {
    var _this2 = this;

    // Always return a promise
    return new Promise(function (resolve) {
      // If the thread isn't set, listen for the threadChanged event
      if (!_this2.thread) {
        _this2.once('threadChanged', function () {
          resolve(_this2.thread.promise());
        });
      } else {
        resolve(_this2.thread.promise());
      }
    });
  };

  return Job;
}(_eventemitter2.default);

exports.default = Job;
//# sourceMappingURL=job.js.map


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;

var _eventemitter = __webpack_require__(4);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _job = __webpack_require__(36);

var _job2 = _interopRequireDefault(_job);

var _defaults = __webpack_require__(19);

var _defaults2 = _interopRequireDefault(_defaults);

var _ = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pool = function (_EventEmitter) {
  _inherits(Pool, _EventEmitter);

  function Pool(threads) {
    _classCallCheck(this, Pool);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.threads = Pool.spawn(threads || _defaults2.default.pool.size);
    _this.idleThreads = _this.threads.slice();
    _this.jobQueue = [];
    _this.runArgs = [];

    _this.on('newJob', function (job) {
      return _this.handleNewJob(job);
    });
    _this.on('threadAvailable', function () {
      return _this.dequeue();
    });
    return _this;
  }

  Pool.prototype.run = function run() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.runArgs = args;
    return this;
  };

  Pool.prototype.send = function send() {
    if (!this.runArgs) {
      throw new Error('Pool.send() called without prior Pool.run(). You need to define what to run first.');
    }

    var job = new _job2.default(this);
    job.run.apply(job, this.runArgs);
    return job.send.apply(job, arguments);
  };

  Pool.prototype.killAll = function killAll() {
    this.threads.forEach(function (thread) {
      thread.kill();
    });
  };

  Pool.prototype.queueJob = function queueJob(job) {
    this.jobQueue.push(job);
    this.dequeue();
  };

  Pool.prototype.dequeue = function dequeue() {
    var _this2 = this;

    if (this.jobQueue.length === 0 || this.idleThreads.length === 0) {
      return;
    }

    var job = this.jobQueue.shift();
    var thread = this.idleThreads.shift();

    job.once('done', function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this2.handleJobSuccess.apply(_this2, [thread, job].concat(args));
    }).once('error', function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this2.handleJobError.apply(_this2, [thread, job].concat(args));
    });

    job.executeOn(thread);
  };

  Pool.prototype.handleNewJob = function handleNewJob(job) {
    var _this3 = this;

    this.lastCreatedJob = job;
    job.once('readyToRun', function () {
      return _this3.queueJob(job);
    }); // triggered by job.send()
  };

  Pool.prototype.handleJobSuccess = function handleJobSuccess(thread, job) {
    for (var _len4 = arguments.length, responseArgs = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      responseArgs[_key4 - 2] = arguments[_key4];
    }

    this.emit.apply(this, ['done', job].concat(responseArgs));
    this.handleJobDone(thread);
  };

  Pool.prototype.handleJobError = function handleJobError(thread, job, error) {
    this.emit('error', job, error);
    this.handleJobDone(thread);
  };

  Pool.prototype.handleJobDone = function handleJobDone(thread) {
    var _this4 = this;

    this.idleThreads.push(thread);
    this.emit('threadAvailable');

    if (this.idleThreads.length === this.threads.length) {
      // run deferred to give other job.on('done') handlers time to run first
      setTimeout(function () {
        _this4.emit('finished');
      }, 0);
    }
  };

  return Pool;
}(_eventemitter2.default);

exports.default = Pool;


Pool.spawn = function (threadCount) {
  var threads = [];

  for (var threadIndex = 0; threadIndex < threadCount; threadIndex++) {
    threads.push((0, _.spawn)());
  }

  return threads;
};
//# sourceMappingURL=pool.js.map


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;

var _slaveCode = __webpack_require__(39);

var _slaveCode2 = _interopRequireDefault(_slaveCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slaveCodeDataUri = 'data:text/javascript;charset=utf-8,' + encodeURI(_slaveCode2.default);
var createBlobURL = window.createBlobURL || window.createObjectURL;

if (!createBlobURL) {
  var URL = window.URL || window.webkitURL;

  if (URL) {
    createBlobURL = URL.createObjectURL;
  } else {
    throw new Error('No Blob creation implementation found.');
  }
}

if (typeof window.BlobBuilder === 'function' && typeof createBlobURL === 'function') {
  var blobBuilder = new window.BlobBuilder();
  blobBuilder.append(_slaveCode2.default);
  slaveCodeDataUri = createBlobURL(blobBuilder.getBlob());
} else if (typeof window.Blob === 'function' && typeof createBlobURL === 'function') {
  var blob = new window.Blob([_slaveCode2.default], { type: 'text/javascript' });
  slaveCodeDataUri = createBlobURL(blob);
}

exports.default = slaveCodeDataUri;
//# sourceMappingURL=slave-code-uri.js.map


/***/ },
/* 39 */
/***/ function(module, exports) {

module.exports = "/*eslint-env worker*/\n/*global importScripts*/\n/*eslint-disable no-console*/\nself.module = {\n  exports : function() {\n    if (console) { console.error('No thread logic initialized.'); }\n  }\n};\n\nfunction handlerDone() {\n  var args = Array.prototype.slice.call(arguments, 0);\n  this.postMessage({ response : args });\n}\n\nfunction handlerProgress(progress) {\n  this.postMessage({ progress : progress });\n}\n\nfunction handlerDoneTransfer() {\n  var args = Array.prototype.slice.call(arguments);\n  var lastArg = args.pop();\n\n  if (!(lastArg instanceof Array) && this.console) {\n    console.error('Expected 2nd parameter of <doneCallback>.transfer() to be an array. Got:', lastArg);\n  }\n\n  this.postMessage({ response : args }, lastArg);\n}\n\nself.onmessage = function (event) {\n  var scripts = event.data.scripts;\n  if (scripts && scripts.length > 0 && typeof importScripts !== 'function') {\n    throw new Error('importScripts() not supported.');\n  }\n\n  if (event.data.initByScripts) {\n    importScripts.apply(null, scripts);\n  }\n\n  if (event.data.initByMethod) {\n    var method = event.data.method;\n    this.module.exports = Function.apply(null, method.args.concat(method.body));\n\n    if (scripts && scripts.length > 0) {\n      importScripts.apply(null, scripts);\n    }\n  }\n\n  if (event.data.doRun) {\n    var handler = this.module.exports;\n    if (typeof handler !== 'function') {\n      throw new Error('Cannot run thread logic. No handler has been exported.');\n    }\n\n    var preparedHandlerDone = handlerDone.bind(this);\n    preparedHandlerDone.transfer = handlerDoneTransfer.bind(this);\n\n    handler.call(this, event.data.param, preparedHandlerDone, handlerProgress.bind(this));\n  }\n}.bind(self);\n";

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _eventemitter = __webpack_require__(4);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _slaveCodeUri = __webpack_require__(38);

var _slaveCodeUri2 = _interopRequireDefault(_slaveCodeUri);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (_typeof(window.Worker) !== 'object' && typeof window.Worker !== 'function') {
  throw new Error('Browser does not support web workers!');
}

function joinPaths(path1, path2) {
  if (!path1 || !path2) {
    return path1 + path2;
  } else if (path1.charAt(path1.length - 1) === '/' || path2.charAt(0) === '/') {
    return path1 + path2;
  } else {
    return path1 + '/' + path2;
  }
}

function prependScriptUrl(scriptUrl) {
  var prefix = (0, _config.getConfig)().basepath.web;
  return prefix ? joinPaths(prefix, scriptUrl) : scriptUrl;
}

function convertToArray(input) {
  var outputArray = [];
  var index = 0;

  while (typeof input[index] !== 'undefined') {
    outputArray.push(input[index]);
    index++;
  }

  return outputArray;
}

function logError(error) {
  if (error.stack) {
    console.error(error.stack); // eslint-disable-line no-console
  } else if (error.message && error.filename && error.lineno) {
    var fileName = error.filename.match(/^data:text\/javascript/) && error.filename.length > 50 ? error.filename.substr(0, 50) + '...' : error.filename;
    console.error(error.message + ' @' + fileName + ':' + error.lineno); // eslint-disable-line no-console
  } else {
    console.error(error); // eslint-disable-line no-console
  }
}

var Worker = function (_EventEmitter) {
  _inherits(Worker, _EventEmitter);

  function Worker() {
    var initialScript = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var importScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Worker);

    // used by `run()` to decide if the worker must be re-initialized
    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.currentRunnable = null;
    _this.currentImportScripts = [];

    _this.initWorker();
    _this.worker.addEventListener('message', _this.handleMessage.bind(_this));
    _this.worker.addEventListener('error', _this.handleError.bind(_this));

    if (initialScript) {
      _this.run(initialScript, importScripts);
    }
    return _this;
  }

  Worker.prototype.initWorker = function initWorker() {
    try {
      this.worker = new window.Worker(_slaveCodeUri2.default);
    } catch (error) {
      var slaveScriptUrl = (0, _config.getConfig)().fallback.slaveScriptUrl;
      if (slaveScriptUrl) {
        // try using the slave script file instead of the data URI
        this.worker = new window.Worker(_slaveCodeUri2.default);
      } else {
        // re-throw
        throw error;
      }
    }
  };

  Worker.prototype.run = function run(toRun) {
    var importScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (this.alreadyInitializedToRun(toRun, importScripts)) {
      // don't re-initialize with the new logic if it already has been
      return this;
    }

    if (typeof toRun === 'function') {
      this.runMethod(toRun, importScripts);
    } else {
      this.runScripts(toRun, importScripts);
    }

    this.currentRunnable = toRun;
    this.currentImportScripts = importScripts;

    return this;
  };

  Worker.prototype.runMethod = function runMethod(method, importScripts) {
    var methodStr = method.toString();
    var args = methodStr.substring(methodStr.indexOf('(') + 1, methodStr.indexOf(')')).split(',');
    var body = methodStr.substring(methodStr.indexOf('{') + 1, methodStr.lastIndexOf('}'));

    this.worker.postMessage({
      initByMethod: true,
      method: { args: args, body: body },
      scripts: importScripts.map(prependScriptUrl)
    });
  };

  Worker.prototype.runScripts = function runScripts(script, importScripts) {
    if (!script) {
      throw new Error('Must pass a function or a script URL to run().');
    }

    // attention: array for browser, single script for node
    this.worker.postMessage({
      initByScripts: true,
      scripts: importScripts.concat([script]).map(prependScriptUrl)
    });
  };

  Worker.prototype.send = function send(param) {
    var transferables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    this.worker.postMessage({
      doRun: true,
      param: param
    }, transferables);
    return this;
  };

  Worker.prototype.kill = function kill() {
    this.worker.terminate();
    this.emit('exit');
    return this;
  };

  Worker.prototype.promise = function promise() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      var resolved = void 0,
          rejected = void 0;
      resolved = function resolved(result) {
        _this2.removeListener('error', rejected);
        resolve(result);
      };
      rejected = function rejected(err) {
        _this2.removeListener('message', resolved);
        reject(err);
      };

      _this2.once('message', resolved).once('error', rejected);
    });
  };

  Worker.prototype.alreadyInitializedToRun = function alreadyInitializedToRun(toRun, importScripts) {
    var runnablesMatch = this.currentRunnable === toRun;
    var importScriptsMatch = this.currentImportScripts === importScripts || importScripts.length === 0 && this.currentImportScripts.length === 0;

    return runnablesMatch && importScriptsMatch;
  };

  Worker.prototype.handleMessage = function handleMessage(event) {
    if (event.data.error) {
      this.handleError(event.data.error);
    } else if (event.data.progress) {
      this.handleProgress(event.data.progress);
    } else {
      var responseArgs = convertToArray(event.data.response);
      this.emit.apply(this, ['message'].concat(responseArgs));
      this.emit.apply(this, ['done'].concat(responseArgs)); // this one is just for convenience
    }
  };

  Worker.prototype.handleProgress = function handleProgress(progress) {
    this.emit('progress', progress);
  };

  Worker.prototype.handleError = function handleError(error) {
    if (!this.listeners('error', true)) {
      logError(error);
    }

    if (error.preventDefault) {
      error.preventDefault();
    }

    this.emit('error', error);
  };

  return Worker;
}(_eventemitter2.default);

exports.default = Worker;
//# sourceMappingURL=worker.js.map


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {'use strict';

/*eslint-env node*/
/*
 * This file is only a stub to make './worker' resolve the './worker.node/worker' module.
 * Loading the browser worker into the browser bundle is done in the gulpfile by
 * configuring a browserify override.
 */

if (typeof process !== 'undefined' && 'pid' in process) {
  module.exports = __webpack_require__(42);
} else {
  module.exports = __webpack_require__(40);
}
//# sourceMappingURL=worker.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';

exports.__esModule = true;

var _child_process = __webpack_require__(44);

var _child_process2 = _interopRequireDefault(_child_process);

var _path = __webpack_require__(45);

var _path2 = _interopRequireDefault(_path);

var _eventemitter = __webpack_require__(4);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Worker = function (_EventEmitter) {
  _inherits(Worker, _EventEmitter);

  function Worker(initialRunnable) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Worker);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.slave = _child_process2.default.fork(_path2.default.join(__dirname, 'slave.js'), [], options);
    _this.slave.on('message', _this.handleMessage.bind(_this));
    _this.slave.on('error', _this.handleError.bind(_this));
    _this.slave.on('exit', _this.emit.bind(_this, 'exit'));

    if (initialRunnable) {
      _this.run(initialRunnable);
    }
    return _this;
  }

  Worker.prototype.run = function run(toRun) {
    if (typeof toRun === 'function') {
      this.runMethod(toRun);
    } else {
      this.runScript(toRun);
    }
    return this;
  };

  Worker.prototype.runMethod = function runMethod(method) {
    this.slave.send({
      initByMethod: true,
      method: method.toString()
    });
  };

  Worker.prototype.runScript = function runScript(script) {
    if (!script) {
      throw new Error('Must pass a function or a script path to run().');
    }

    var prefixedScriptPath = _path2.default.join((0, _config.getConfig)().basepath.node, script);

    // attention: single script for node, array for browser
    this.slave.send({
      initByScript: true,
      script: _path2.default.resolve(prefixedScriptPath)
    });
  };

  Worker.prototype.send = function send(param) {
    this.slave.send({
      doRun: true,
      param: param
    });
    return this;
  };

  Worker.prototype.kill = function kill() {
    this.slave.kill();
    return this;
  };

  Worker.prototype.promise = function promise() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      var resolved = void 0,
          rejected = void 0;
      resolved = function resolved(result) {
        _this2.removeListener('error', rejected);
        resolve(result);
      };
      rejected = function rejected(err) {
        _this2.removeListener('message', resolved);
        reject(err);
      };

      _this2.once('message', resolved).once('error', rejected);
    });
  };

  Worker.prototype.handleMessage = function handleMessage(message) {
    if (message.error) {
      var error = new Error(message.error.message);
      error.stack = message.error.stack;

      this.handleError(error);
    } else if (message.progress) {
      this.handleProgress(message.progress);
    } else {
      this.emit.apply(this, ['message'].concat(message.response));
      this.emit.apply(this, ['done'].concat(message.response)); // this one is just for convenience
    }
  };

  Worker.prototype.handleProgress = function handleProgress(progress) {
    this.emit('progress', progress);
  };

  Worker.prototype.handleError = function handleError(error) {
    if (!this.listeners('error', true)) {
      console.error(error.stack || error); // eslint-disable-line no-console
    }
    this.emit('error', error);
  };

  return Worker;
}(_eventemitter2.default);

exports.default = Worker;
//# sourceMappingURL=worker.js.map

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 43 */
/***/ function(module, exports) {

/* (ignored) */

/***/ },
/* 44 */
/***/ function(module, exports) {

/* (ignored) */

/***/ },
/* 45 */
/***/ function(module, exports) {

/* (ignored) */

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// common.js